import React from 'react';
import OpenOsV2View from './OpenOsV2View';
import { submitOpenOsV2Orders, submitSchedulePreventiveOrders } from './openOsV2CreateOs';
import { maybeAutoSendOpenOsEmails, sendOpenOsAberturaEmails } from './openOsV2Notify';
import OsReportV2PreviewModal from '../../board/components/os-report-v2/OsReportV2PreviewModal';
import { checkOpenOS, checkRetiradaAtivaAbertura, getContractEquipment } from '../services/equipmentService';
import {
  addressKeyFromEquipRaw,
  clearOpenOsV2EquipSearchCache,
  contractCodigoFromHit,
  formatLocationLabel,
  formatSiteAddressFromRaw,
  locationFieldsFromEquipRaw,
  mapContractEquipmentToLocais,
} from '../utils/openOsV2SearchBridge';
import { getContractExpiryWarning } from '../../../utils/contratoVencimento';
import { fetchAgendaNearbyTechs, fetchAgendaMonitoredLocations, padAgendaCodTec } from '../services/scheduleService';
import { buildTechColorMap, colorForTech } from './openOsV2RouteHelpPins';
import {
  CONFIG_TIPO_OS_OPTIONS,
  getAllowedTipoValuesForAbertura,
  getConfigTipoValuesForDefeito,
  getDefeitoTipoBadges,
  isDefeitoAllowedForAbertura,
  TIPO_OS_VALUE_LABELS,
  userOsLoadFlagsToValues,
} from '../utils/defeitoTipoRules';

// eslint-disable-next-line no-unused-vars
const EQUIPS = [
  { serie: "AK92013262C0", patrimonio: "OE442", modelo: "MULTIFUNCIONAL OKIDATA PB ES 4172", instalado: "30/01/2023" },
  { serie: "AK92013263C0", patrimonio: "AC339", modelo: "MULTIFUNCIONAL OKIDATA PB ES 4172", instalado: "30/01/2023" },
  { serie: "AK92013264C0", patrimonio: "AC340", modelo: "MULTIFUNCIONAL OKIDATA PB ES 4172", instalado: "12/02/2023" },
  { serie: "AK92013265C0", patrimonio: "AC341", modelo: "MULTIFUNCIONAL OKIDATA PB ES 4172", instalado: "12/02/2023" },
  { serie: "BW09016914C0", patrimonio: "AC623", modelo: "MULTIFUNCIONAL OKIDATA PB ES5162", instalado: "05/07/2023" },
  { serie: "BW09016915C0", patrimonio: "AC624", modelo: "MULTIFUNCIONAL HP COLOR LASERJET PRO M479FDW", instalado: "05/07/2023" }
];

// eslint-disable-next-line no-unused-vars
const CLIENTE_UNICO = "019/2023 MUNICIPIO DE PATY DO ALFERES (SECRETARIA MUNICIPAL DE SAUDE)";
// eslint-disable-next-line no-unused-vars
const ENDERECO_UNICO = "RUA PACHECO, 100 GRANJA CALIFORNIA, PATY DO ALFERES - RJ, 26950000";

// eslint-disable-next-line no-unused-vars
const CLIENTES = [
  { codigo: "(007/2024 CMA)", nome: "CAMARA MUNICIPAL DE ANGRA DOS REIS CMAR" },
  { codigo: "(ANGRA_VINICI)", nome: "CLOVIS JOSE SOARES ANGRA - VINICIUS" },
  { codigo: "(04/2022HMJ)", nome: "FUNDO MUNICIPAL DE SAUDE FUSAR ANGRA DOS REIS HMJ" },
  { codigo: "(005/2019)", nome: "FUNDO MUNICIPAL DE SAUDE FUSAR ANGRA DOS REIS" },
  { codigo: "(019/2023)", nome: "MUNICIPIO DE PATY DO ALFERES (SECRETARIA MUNICIPAL DE SAUDE)" }
];

// eslint-disable-next-line no-unused-vars
const LOCAIS = [
  { nome: "RUA DA CONCEICAO 255", modelos: [
    { nome: "MULTIFUNCIONAL OKIDATA PB ES 4172", series: [
      { serie: "AK92013262C0", patrimonio: "OE442" }, { serie: "AK92013263C0", patrimonio: "AC339" }, { serie: "AK92013264C0", patrimonio: "AC340" }
    ] },
    { nome: "MULTIFUNCIONAL LASER A4 MONO HP E52645C FLOW 48 PPM", series: [
      { serie: "CN82041771C0", patrimonio: "AC501" }, { serie: "CN82041772C0", patrimonio: "AC502" }
    ] }
  ] },
  { nome: "CT 003/2020 RUA DA CONCEIÇÃO", modelos: [
    { nome: "MULTIFUNCIONAL OKIDATA PB ES5162", series: [
      { serie: "BW09016885C0", patrimonio: "AC622" }, { serie: "BW09016914C0", patrimonio: "AC623" },
      { serie: "BW09016915C0", patrimonio: "AC624" }, { serie: "BW09016917C0", patrimonio: "AC625" }
    ] },
    { nome: "MULTIFUNCIONAL HP COLOR LASERJET PRO M479FDW", series: [
      { serie: "HP47901221C0", patrimonio: "AC701" }, { serie: "HP47901222C0", patrimonio: "AC702" }
    ] },
    { nome: "MULTIFUNCIONAL HP PRO 4103 FDW MFP LASER PB 40PPM A4", series: [
      { serie: "HP41031001C0", patrimonio: "AC810" }, { serie: "HP41031002C0", patrimonio: "AC811" }
    ] }
  ] },
  { nome: "RUA ALMIRANTE BRASIL", modelos: [
    { nome: "MULTIFUNCIONAL OKIDATA PB ES 4172", series: [ { serie: "AK92013299C0", patrimonio: "AC390" } ] }
  ] }
];

const DEFEITOS = ["ATOLAMENTO", "BARULHO NA HORA DE LIGAR", "MANCHA NA IMPRESSÃO", "MÁQUINA TRAVADA MOSTRANDO CÓDIGO", "NÃO LIGA / SEM ENERGIA", "TONER COM BAIXO RENDIMENTO"];
const TIPO_OS_OPTIONS = [
  { label: "Corretiva", value: "N" },
  { label: "Instalação", value: "I" },
  { label: "Preventiva", value: "S" },
  { label: "Aferição", value: "A" },
  { label: "Desinstalação", value: "D" },
  { label: "Recarga", value: "R" },
  { label: "Estoque", value: "E" },
  { label: "Balcão", value: "B" }
];
const TIPOS_CONTATO = ["Fone1", "WhatsApp", "Fone2"];
const DOW = ["DOM", "SEG", "TER", "QUA", "QUI", "SEX", "SÁB"];

const REGIOES = [
  { nome: "Vale do Paraíba", coordenador: "R. ALMEIDA", tecnicos: [{ nome: "BRUNO SANTOS", carga: "3 OS hoje" }, { nome: "FABIANO JOSE", carga: "5 OS hoje" }, { nome: "GABRIEL COSTA", carga: "1 OS hoje" }] },
  { nome: "Zona Sul BH", coordenador: "M. TAVARES", tecnicos: [{ nome: "KIM KATAGUIRI", carga: "2 OS hoje" }, { nome: "DEMILSON CASTANHO", carga: "4 OS hoje" }] },
  { nome: "Região Leste", coordenador: "P. SOUZA", tecnicos: [{ nome: "ANDERSON LIMA", carga: "6 OS hoje" }] },
  { nome: "Zona Norte", coordenador: "C. RIBEIRO", tecnicos: [{ nome: "JOSE MARCOS", carga: "0 OS hoje" }] }
];

// eslint-disable-next-line no-unused-vars
const ULTIMO = {
  os: "299959", data: "09/05/2025", tipo: "NORMAL", tecnico: "DEMILSON CASTANHO", solicitante: "MARIA APARECIDA",
  motivo: "BARULHO NA HORA DE LIGAR",
  defeito: "MAQUINA TRAVADA MOSTRANDO CÓDIGO-A",
  observacao: "BARULHO NA HORA DE LIGAR, DEPOIS PEDE PARA VERIFICAR CILINDRO LOGO EM SEGUIDA DESLIGA SOZINHA",
  solucao: "OBRIGATÓRIO REGISTRAR OS CONTADORES. Promover limpeza do equipamento, independente do defeito. Avaliar possível reset.",
  laudoData: "11/05/2025 12:41 → 14:23",
  laudoTexto: "FEITO VERIFICAÇÃO, MANUTENÇÃO E REPAROS NO EQUIPAMENTO COM A RECUPERAÇÃO DA UNIDADE DE IMAGEM, ABERTURA E LIMPEZA INTERNA NA MESMA, LIMPEZA GERAL NO EQUIPAMENTO E REINSTALAÇÃO DO MESMO.",
  contadores: [
    { label: "P&B", valor: "95.614" }, { label: "Color", valor: "0" }, { label: "DG", valor: "0" }, { label: "A3 P&B", valor: "0" }, { label: "A3 Color", valor: "0" }
  ]
};

const HIST_PARETO = [
  { defeito: "ATOLAMENTO", qtd: 6 },
  { defeito: "MANCHA NA IMPRESSÃO", qtd: 4 },
  { defeito: "BARULHO NA HORA DE LIGAR", qtd: 3 },
  { defeito: "MÁQUINA TRAVADA COM CÓDIGO", qtd: 2 },
  { defeito: "NÃO LIGA / SEM ENERGIA", qtd: 2 },
  { defeito: "TONER COM BAIXO RENDIMENTO", qtd: 1 }
];

const HIST_ORDENS = [
  { numero: "299959", tipo: "Corretiva", abertura: "09/05/2025", defeito: "BARULHO NA HORA DE LIGAR", defeitoAlert: "A12", colorBg: "#8458fe", tecnico: "DEMILSON CASTANHO", condicao: "01 — Atendido OK", fechamento: "11/05/2025", cliente: "019/2023", contadores: [95614, 0, 1208, 0, 0],
    motivo: "Barulho na hora de ligar, depois pede para verificar cilindro e desliga sozinha.",
    laudo: "Realizada a troca da unidade de imagem, limpeza interna geral e reinstalação do equipamento. Cilindro ruim: 2223000619B1 KA. Cilindro novo: 2239004513B1 KB.",
    pecas: [{ codigo: "20471", referencia: "44574317", produto: "CILINDRO OKIDATA 431/4172/5112 UNIDADE 30K", qtde: 1 }] },
  { numero: "297431", tipo: "Preventiva", abertura: "12/02/2025", defeito: "REVISÃO PREVENTIVA SEMESTRAL", tecnico: "KIM KATAGUIRI", condicao: "01 — Atendido OK", fechamento: "12/02/2025", cliente: "019/2023", contadores: [88902, 0, 1104, 0, 0],
    motivo: "Preventiva programada de contrato.", laudo: "Limpeza geral, verificação de roletes e atualização de firmware. Nenhuma peça substituída.", pecas: [] },
  { numero: "295118", tipo: "Corretiva", abertura: "28/11/2024", defeito: "ATOLAMENTO", defeitoAlert: "A03", colorBg: "#d1544a", tecnico: "BRUNO SANTOS", condicao: "03 — Peça substituída", fechamento: "29/11/2024", cliente: "019/2023", contadores: [81470, 0, 998, 0, 0], reincidenteDe: "290877",
    motivo: "Instalar/trocar peças. Pedido: PD-39012.", laudo: "Substituídos os roletes de arraste da bandeja 1, que apresentavam desgaste. Testes de alimentação sem novos atolamentos.",
    pecas: [{ codigo: "18902", referencia: "45762002", produto: "ROLETE DE ARRASTE (PICK-UP) BANDEJA 1", qtde: 2 }] },
  { numero: "293004", tipo: "Corretiva", abertura: "03/09/2024", defeito: "MANCHA NA IMPRESSÃO", defeitoAlert: "A08", colorBg: "#d99320", tecnico: "FABIANO JOSE", condicao: "01 — Atendido OK", fechamento: "04/09/2024", cliente: "019/2023", contadores: [74226, 0, 902, 0, 0],
    motivo: "Cliente relatou manchas verticais nas cópias.", laudo: "Limpeza do conjunto óptico e do cilindro. Impressões de teste aprovadas.", pecas: [] },
  { numero: "290877", tipo: "Corretiva", abertura: "17/06/2024", defeito: "ATOLAMENTO", defeitoAlert: "A03", colorBg: "#d1544a", tecnico: "BRUNO SANTOS", condicao: "02 — Reincidente", fechamento: "18/06/2024", cliente: "019/2023", contadores: [66310, 0, 845, 0, 0],
    motivo: "Atolamento recorrente na bandeja 1. Pedido: PD-36755.", laudo: "Substituída a unidade fusora com desgaste. Ajuste do guia de papel.",
    pecas: [{ codigo: "17330", referencia: "44574301", produto: "UNIDADE FUSORA 220V", qtde: 1 }] },
  { numero: "288450", tipo: "Preventiva", abertura: "20/03/2024", defeito: "REVISÃO PREVENTIVA SEMESTRAL", tecnico: "KIM KATAGUIRI", condicao: "01 — Atendido OK", fechamento: "20/03/2024", cliente: "019/2023", contadores: [58004, 0, 781, 0, 0],
    motivo: "Preventiva programada de contrato.", laudo: "Limpeza geral e verificação de contadores. Equipamento em boas condições.", pecas: [] },
  { numero: "286112", tipo: "Corretiva", abertura: "05/01/2024", defeito: "MÁQUINA TRAVADA COM CÓDIGO", defeitoAlert: "A01", colorBg: "#8458fe", tecnico: "GABRIEL COSTA", condicao: "01 — Atendido OK", fechamento: "08/01/2024", cliente: "019/2023", contadores: [49881, 0, 702, 0, 0],
    motivo: "Equipamento travando com código de erro na inicialização.", laudo: "Executado reset de fábrica e reinstalação do firmware. Equipamento normalizado.", pecas: [] },
  { numero: "283790", tipo: "Corretiva", abertura: "22/09/2023", defeito: "NÃO LIGA / SEM ENERGIA", defeitoAlert: "A05", colorBg: "#12a45a", tecnico: "ANDERSON LIMA", condicao: "03 — Peça substituída", fechamento: "25/09/2023", cliente: "019/2023", contadores: [38145, 0, 560, 0, 0],
    motivo: "Equipamento não liga. Pedido: PD-33120.", laudo: "Diagnosticada falha na fonte de alimentação. Placa substituída e testada em carga.",
    pecas: [{ codigo: "15104", referencia: "42931502", produto: "PLACA DE FONTE DE ALIMENTAÇÃO", qtde: 1 }] }
];

const HIST_COLUNAS = [
  { key: "tipo", label: "Tipo", largura: "84px", min: 84 },
  { key: "abertura", label: "Abertura", largura: "78px", min: 78 },
  { key: "defeito", label: "Defeito", largura: "minmax(150px,1.2fr)", min: 150 },
  { key: "tecnico", label: "Técnico", largura: "104px", min: 104 },
  { key: "condicao", label: "Condição final", largura: "minmax(140px,1.15fr)", min: 140 },
  { key: "fechamento", label: "Fechamento", largura: "78px", min: 78 },
  { key: "pb", label: "A4 P&B", largura: "84px", min: 84 },
  { key: "color", label: "A4 Color", largura: "84px", min: 84 },
  { key: "dig", label: "Digitalização", largura: "88px", min: 88 },
  { key: "a3pb", label: "A3 P&B", largura: "80px", min: 80 },
  { key: "a3color", label: "A3 Color", largura: "80px", min: 80 },
  { key: "cliente", label: "Cliente", largura: "84px", min: 84 }
];
const CONTADOR_IDX = { pb: 0, color: 1, dig: 2, a3pb: 3, a3color: 4 };
const PECA_COLUNAS = [
  { key: "data", label: "Data", largura: "74px", min: 74 },
  { key: "codigo", label: "Código", largura: "76px", min: 76 },
  { key: "peca", label: "Peça / referência", largura: "minmax(130px,1.3fr)", min: 130 },
  { key: "qtde", label: "Qtde", largura: "44px", min: 44 },
  { key: "os", label: "OS", largura: "70px", min: 70 },
  { key: "vida", label: "Vida útil", largura: "84px", min: 84 },
  { key: "pb", label: "A4 P&B", largura: "86px", min: 86 },
  { key: "color", label: "A4 Color", largura: "86px", min: 86 },
  { key: "total", label: "Total", largura: "90px", min: 90 }
];
const PECA_CONTADOR_IDX = { pb: 0, color: 1, total: 2 };

const PRODUCAO_MESES = ["dez/24", "jan/25", "fev/25", "mar/25", "abr/25", "mai/25"];
const PRODUCAO_SERIES = [
  { key: "pb", label: "A4 P&B", cor: "#7c4dff", fill: "rgba(124,77,255,.35)", valores: [6310, 5980, 6740, 7120, 6480, 7310], medAtual: [82000, 87980, 94720, 101840, 108320, 115630] },
  { key: "color", label: "A4 Color", cor: "#06b6d4", fill: "rgba(6,182,212,.35)", valores: [820, 760, 910, 1040, 980, 1120], medAtual: [12400, 13160, 14070, 15110, 16090, 17210] },
  { key: "dig", label: "Digitalização", cor: "#10b981", fill: "rgba(16,185,129,.35)", valores: [180, 210, 160, 240, 220, 260], medAtual: [4100, 4310, 4470, 4710, 4930, 5190] },
  { key: "a3pb", label: "A3 P&B", cor: "#d99320", fill: "rgba(217,147,32,.30)", valores: [90, 120, 80, 140, 110, 130], medAtual: [2100, 2220, 2300, 2440, 2550, 2680] },
  { key: "a3color", label: "A3 Color", cor: "#d1544a", fill: "rgba(209,84,74,.30)", valores: [40, 30, 60, 50, 70, 45], medAtual: [880, 910, 970, 1020, 1090, 1135] }
];
const nf = (n) => n.toLocaleString("pt-BR");
const fmtPct = (n) => {
  const abs = Math.abs(n);
  const s = abs.toLocaleString("pt-BR", { maximumFractionDigits: 1, minimumFractionDigits: abs < 10 && abs % 1 !== 0 ? 1 : 0 });
  return (n >= 0 ? "+" : "−") + s + "%";
};

const HIST_PECAS = [
  { pedido: "PD-41288", data: "11/05/2025", codigo: "45435104", referencia: "OKI-ES4172-DR", nome: "UNIDADE DE IMAGEM (CILINDRO)", qtde: 1, os: "299959", vidaUtil: "25.000 pág.", contadores: [95614, 0, 96822] },
  { pedido: "PD-39012", data: "29/11/2024", codigo: "45762002", referencia: "OKI-ROL-PICK", nome: "ROLETE DE ARRASTE (PICK-UP)", qtde: 2, os: "295118", vidaUtil: "60.000 pág.", contadores: [81470, 0, 82468] },
  { pedido: "PD-36755", data: "18/06/2024", codigo: "44574301", referencia: "OKI-FUSER-220", nome: "UNIDADE FUSORA 220V", qtde: 1, os: "290877", vidaUtil: "100.000 pág.", contadores: [66310, 0, 67155] },
  { pedido: "PD-33120", data: "25/09/2023", codigo: "42931502", referencia: "OKI-PSU-BRD", nome: "PLACA DE FONTE DE ALIMENTAÇÃO", qtde: 1, os: "283790", vidaUtil: "sem limite", contadores: [38145, 0, 38705] }
];

// eslint-disable-next-line no-unused-vars
const SUGESTOES = [
  "RUA PACHECO, 100 — GRANJA CALIFORNIA, PATY DO ALFERES - RJ, 26950-000",
  "RUA PACHECO, 118 — CENTRO, PATY DO ALFERES - RJ, 26950-000",
  "AV. GETÚLIO VARGAS, 45 — CENTRO, PATY DO ALFERES - RJ, 26950-010"
];

const CHIP_OFF = "padding:6px 12px;border-radius:9px;border:1px solid #e6e6ef;background:#fff;color:#5c5c70;font-size:12px;font-weight:700;cursor:pointer";
const CHIP_ON = "padding:6px 12px;border-radius:9px;border:1px solid #6d3ef5;background:#6d3ef5;color:#fff;font-size:12px;font-weight:700;cursor:pointer;box-shadow:0 1px 2px rgba(109,62,245,.35)";
const INPUT_BASE = "width:100%;height:34px;border-radius:8px;padding:0 10px;font-size:13px;outline:none;background:var(--input-bg, #fff);border:1px solid ";
const QUANDO_BASE = "display:flex;flex-direction:column;align-items:center;justify-content:center;gap:3px;padding:11px 8px;border-radius:12px;cursor:pointer;min-height:96px;transition:border-color .15s,background .15s;";
const MONITORED_POLL_MS = 10000;

function isGoPremium(goIdProduto) {
  return Number(goIdProduto) === 4;
}

class OpenOsV2App extends React.Component {
  state = {
    step: 0, origem: null, modo: null, query: "", equip: null, cliente: null,
    apiHits: [], apiSearching: false,
    locaisLive: [],
    sel: [], selEstoqueBySerie: {}, abertosLocais: [], abertosModelos: [], filtro: "", listaModal: false,
    solicitante: "", contatoFone1: "", contatoWhatsApp: "", contatoFone2: "", tipoContato: "Fone1",
    email: "", emails: [], emailDraft: "",
    corrigindoEndereco: false, enderecoQuery: "", endereco: "",
    enderecoHits: [], enderecoSearching: false, enderecoOriginal: "", enderecoParsed: null,
    editandoLocalInterno: false, localInternoDraft: "", localInterno: "",
    clienteLabel: "", contratoVencidoFlag: false, ultimoLive: null, temUltimo: false,
    histLive: null, histLoading: false,
    histPeriodMonths: 24,
    periodoAberto: false,
    ultimoAberto: false, defeitoDetalheAberto: false, laudoAberto: false,
    defeitoQuery: "", defeito: "", defeitoCodigo: "", defeitoObj: null, defeitoHits: [], defeitoSearching: false, obs: "",
    defeitoEquipVinculoAtivo: false,
    tipoOsValue: null, agendaModal: false, quandoDraft: null, dataDraft: "", semPrevisao: false, standbyNotes: "", tecnicoDraft: null, tecnicoDraftObj: null,
    agendaTechQuery: "",
    scheduleAreasData: null, scheduleAreasLoading: false,
    contadoresAberto: false, contPb: "", contCor: "", contTotal: "",
    lastContPb: 0, lastContCor: 0, lastContTotal: 0, contadoresLoading: false,
    regioesAbertas: [], agenda: null, osGeradas: [], gerandoOS: false, concluido: false, preventivasProgramadas: false, preventivaScheduleDate: null, toast: "", stepperAberto: true,
    historicoAberto: false, histAba: "resumo", histOS: null, histPeca: null,
    colunasAberto: false, colunas: ["tipo", "defeito", "tecnico", "condicao", "fechamento", "pb"],
    colunasPecas: ["data", "codigo", "peca", "qtde", "os", "vida", "pb", "total"],
    seriesProducao: ["pb", "color"],
    ganttTip: null,
    tb02112Loading: { solicitante: false, contato: false, email: false },
    emailModal: null, emailModalList: [], emailModalDraft: "", emailSending: false, emailSentOk: false, emailSendError: "",
    printPreview: null,
    guardAlert: null, guardChecking: false,
    contratoVencModal: null,
    recentOsModal: null,
    routeHelpOpen: false, routeHelpKm: 5, routeHelpLoading: false, routeHelpError: "", routeHelpOrigin: null, routeHelpPoints: [],
    routeHelpAgendaMirrorOpen: false, routeHelpMonitoredTechs: []
  };

  componentDidMount() {
    if (this.props.historyOnly) {
      const he = this.props.historyEquip || {};
      const serie = String(he.serie || "").trim();
      const equip = {
        serie: serie || "—",
        patrimonio: String(he.patrimonio || "").trim() || "—",
        modelo: String(he.modelo || "").trim() || "—",
        instalado: he.instalado || null,
        raw: null,
      };
      this.setState(
        { equip, historicoAberto: true, histAba: "resumo" },
        () => {
          if (serie) this.loadHistoryFromApi(serie, equip.instalado);
        }
      );
    } else if (this.props.agendaOnly) {
      const patch = { agendaModal: true };
      const addr = String(this.props.scheduleOriginAddress || "").trim();
      const city = String(this.props.scheduleOriginCity || "").trim();
      if (addr) patch.endereco = addr;
      if (city) patch.enderecoParsed = { cidade: city };
      this.setState(patch, () => this.loadScheduleAreas());
    } else {
      if (this.props.modoInicial === "Múltipla") this.setState({ modo: "multipla" });
      this.loadDefeitoEquipAssocFlag();
    }
    this._onEquipChoiceKeyDown = (e) => this.handleEquipChoiceKeys(e);
    if (typeof window !== "undefined") {
      window.addEventListener("keydown", this._onEquipChoiceKeyDown);
    }
  }

  componentWillUnmount() {
    this.stopMonitoredPoll();
    if (typeof window !== "undefined" && this._onEquipChoiceKeyDown) {
      window.removeEventListener("keydown", this._onEquipChoiceKeyDown);
    }
  }

  isEstoqueMultipla(s) {
    const st = s || this.state;
    return st.origem === "estoque" && st.modo === "multipla";
  }

  fluxoSteps(s) {
    const st = s || this.state;
    if (this.isEstoqueMultipla(st)) return ["equip", "conf", "defeito", "fim"];
    if (st.modo === "multipla") return ["equip", "sel", "conf", "defeito", "fim"];
    return ["equip", "conf", "defeito", "fim"];
  }

  componentDidUpdate(prevProps, prevState) {
    const prev = prevState || {};
    const s = this.state;
    const isMultipla = s.modo === "multipla";
    const fluxo = this.fluxoSteps(s);
    const atual = fluxo[s.step];
    const prevAtual = fluxo[prev.step];
    if (!s.concluido && atual === "conf" && prevAtual !== "conf") {
      this.focusSoon(".oosv2-solicitante-input");
    }
    if (!s.concluido && atual === "defeito" && prevAtual !== "defeito" && !s.defeito) {
      this.focusSoon(".oosv2-defeito-input");
    }
    if (!s.concluido && atual === "defeito" && !prev.defeito && s.defeito) {
      this.focusSoon(".oosv2-obs-textarea");
    }
    if (this.props.agendaOnly) {
      const nextAddr = String(this.props.scheduleOriginAddress || "").trim();
      const prevAddr = String((prevProps && prevProps.scheduleOriginAddress) || "").trim();
      if (nextAddr && nextAddr !== prevAddr) {
        const city = String(this.props.scheduleOriginCity || "").trim();
        const patch = { endereco: nextAddr };
        if (city) patch.enderecoParsed = { ...(s.enderecoParsed || {}), cidade: city };
        this.setState(patch);
      }
    }
  }

  focusSoon(sel) {
    setTimeout(() => {
      const el = typeof document !== "undefined" ? document.querySelector(sel) : null;
      if (el && typeof el.focus === "function") el.focus();
    }, 50);
  }

  pickQuando(key) {
    if (key === "tecnico" && this.props.hideApenasTecnico) return;
    const closePicker = typeof window !== "undefined" ? window.__openOsV2CloseFutureDatePicker : null;
    if (typeof closePicker === "function") closePicker();
    const patch = { quandoDraft: key };
    if (this.state.quandoDraft === "futuro" && key !== "futuro") {
      patch.dataDraft = "";
      patch.semPrevisao = false;
      patch.standbyNotes = "";
    }
    if (key !== "hoje" && key !== "amanha") {
      this.stopMonitoredPoll();
      patch.routeHelpOpen = false;
      patch.routeHelpAgendaMirrorOpen = false;
      patch.routeHelpOrigin = null;
      patch.routeHelpPoints = [];
      patch.routeHelpError = "";
      patch.routeHelpLoading = false;
      patch.routeHelpMonitoredTechs = [];
      this.setState(patch);
      return;
    }
    this.setState(patch, () => {
      if (this.state.routeHelpOpen) this.buscarRouteHelp();
    });
  }

  resetEquipSearchState(extra) {
    return {
      query: "",
      equip: null,
      cliente: null,
      sel: [],
      selEstoqueBySerie: {},
      locaisLive: [],
      apiHits: [],
      apiSearching: false,
      clienteLabel: "",
      contratoVencidoFlag: false,
      contratoVencModal: null,
      recentOsModal: null,
      ultimoLive: null,
      temUltimo: false,
      histLive: null,
      endereco: "",
      enderecoOriginal: "",
      enderecoParsed: null,
      enderecoHits: [],
      localInterno: "",
      ...(extra || {})
    };
  }

  pickOrigem(key) {
    clearOpenOsV2EquipSearchCache();
    this.setState(this.resetEquipSearchState({ origem: key, modo: null }));
  }

  pickModo(key) {
    clearOpenOsV2EquipSearchCache();
    this.setState(this.resetEquipSearchState({ modo: key, step: 0 }));
    setTimeout(() => {
      const el = typeof document !== "undefined" ? document.querySelector(".oosv2-equip-search-input") : null;
      if (el && typeof el.focus === "function") el.focus();
    }, 40);
  }

  handleEquipChoiceKeys(e) {
    if (this.props.historyOnly || this.props.agendaOnly) return;
    if (!e || e.defaultPrevented || e.altKey || e.ctrlKey || e.metaKey) return;
    const key = e.key;
    if (key !== "1" && key !== "2") return;
    const t = e.target;
    const tag = t && t.tagName;
    if (tag === "INPUT" || tag === "TEXTAREA" || tag === "SELECT" || (t && t.isContentEditable)) return;
    const s = this.state;
    if (!s || s.concluido || s.step !== 0 || s.historicoAberto) return;
    if (!s.origem) {
      e.preventDefault();
      this.pickOrigem(key === "1" ? "contrato" : "estoque");
      return;
    }
    if (!s.modo) {
      e.preventDefault();
      this.pickModo(key === "1" ? "unica" : "multipla");
    }
  }

  selectedHaveSameAddress(selInfos) {
    const keys = [];
    (selInfos || []).forEach((info) => {
      const key = addressKeyFromEquipRaw(info && info.raw);
      if (!key) return;
      if (keys.indexOf(key) < 0) keys.push(key);
    });
    return keys.length <= 1;
  }

  resolveEquipRawForLocation() {
    const s = this.state;
    if (s.equip && s.equip.raw) return s.equip.raw;
    if (s.modo === "multipla" && Array.isArray(s.sel) && s.sel.length) {
      const info = this.infoDe(s.sel[0]);
      return (info && info.raw) || null;
    }
    return null;
  }

  async gerarOrdens({ isMultipla, selInfos, equipBase, tipoOsValue, tipoLabel }) {
    if (this.state.gerandoOS) return;
    const s = this.state;
    const baseList = isMultipla ? selInfos : [{
      modelo: equipBase.modelo,
      serie: equipBase.serie,
      patrimonio: equipBase.patrimonio,
      raw: s.equip && s.equip.raw
    }];
    const sameAddress = !isMultipla || this.selectedHaveSameAddress(baseList);
    const sharedLoc = this.buildOpenOsLocationFields(null, { useSharedCorrection: sameAddress });
    const items = baseList.map((it) => {
      const raw = it.raw || (s.equip && s.equip.raw) || null;
      const loc = sameAddress
        ? sharedLoc
        : this.buildOpenOsLocationFields(raw, {
          useSharedCorrection: false,
          localInterno: (raw && (raw.Endereco_Local || (raw.endereco && raw.endereco.local))) || ""
        });
      return {
        ...it,
        raw,
        loc,
        linha: tipoLabel + " · " + (s.defeito || "—") + " · " + (s.agenda ? s.agenda.tecnico + " em " + s.agenda.data : "sem programação")
      };
    });
    const missingRaw = items.some((it) => !it.raw || !(it.raw.serie || it.serie));
    if (missingRaw) {
      this.flash("Dados do equipamento incompletos para gerar a OS");
      return;
    }
    this.setState({ gerandoOS: true });
    try {
      const filled = (v) => String(v || "").replace(/\D/g, "");
      const result = await submitOpenOsV2Orders({
        origem: s.origem,
        tipoOsValue: tipoOsValue,
        form: {
          solicitante: s.solicitante,
          contatoFone1: s.contatoFone1,
          contatoWhatsApp: s.contatoWhatsApp,
          contatoFone2: s.contatoFone2,
          email: s.email,
          obs: s.obs,
          defeitoCodigo: s.defeitoCodigo
        },
        loc: sharedLoc,
        counters: {
          confirmed: !!(filled(s.contPb) || filled(s.contCor) || filled(s.contTotal)),
          pb: s.contPb,
          cor: s.contCor,
          total: s.contTotal
        },
        agenda: s.agenda,
        items: items
      });
      const failed = (result.lista || []).filter((os) => !os.success);
      if (failed.length && failed.length === result.lista.length) {
        this.flash(failed[0].error || "Erro ao gerar ordem de serviço");
        this.setState({ gerandoOS: false });
        return;
      }
      if (failed.length) {
        this.flash(failed.length + " OS não gerada(s)");
      }
      this.setState({
        osGeradas: result.lista,
        concluido: true,
        gerandoOS: false,
        tipoOsValue: tipoOsValue,
        osOpenLocation: sharedLoc,
        preventivasProgramadas: false,
        preventivaScheduleDate: null
      });
      const onCreated = this.props.onOSCreated;
      if (typeof onCreated === "function" && result.lista.some((os) => os.success)) {
        onCreated({ scheduled: result.scheduled, technicianId: result.technicianId });
      }
      const okList = (result.lista || []).filter((os) => os.success);
      if (okList.length) {
        maybeAutoSendOpenOsEmails({
          recipients: s.emails,
          osItems: okList,
          ctx: this.emailCtxFromState(s)
        }).then((r) => {
          if (r && r.error) this.flash(r.error);
        });
      }
    } catch (err) {
      this.flash((err && err.message) || "Erro ao gerar ordem de serviço");
      this.setState({ gerandoOS: false });
    }
  }

  canProgramarPreventiva() {
    const s = this.state;
    if (s.modo !== "multipla") return false;
    if (String(s.tipoOsValue || "") !== "S") return false;
    const a = s.agenda;
    if (!a) return false;
    if (a.noCertainDate) return false;
    const st = a.scheduleType || this.scheduleTypeFromQuando(a.quando);
    if (st !== "tomorrow" && st !== "future") return false;
    return !!(a.dataIso || a.data);
  }

  async programarPreventivas({ isMultipla, selInfos, equipBase, tipoOsValue, tipoLabel }) {
    if (this.state.gerandoOS) return;
    if (!this.canProgramarPreventiva()) {
      this.flash("Programar exige múltipla + Preventiva + Amanhã/Futura com data");
      return;
    }
    const s = this.state;
    const baseList = isMultipla ? selInfos : [{
      modelo: equipBase.modelo,
      serie: equipBase.serie,
      patrimonio: equipBase.patrimonio,
      raw: s.equip && s.equip.raw
    }];
    const sameAddress = !isMultipla || this.selectedHaveSameAddress(baseList);
    const sharedLoc = this.buildOpenOsLocationFields(null, { useSharedCorrection: sameAddress });
    const items = baseList.map((it) => {
      const raw = it.raw || (s.equip && s.equip.raw) || null;
      const loc = sameAddress
        ? sharedLoc
        : this.buildOpenOsLocationFields(raw, {
          useSharedCorrection: false,
          localInterno: (raw && (raw.Endereco_Local || (raw.endereco && raw.endereco.local))) || ""
        });
      return {
        ...it,
        raw,
        loc,
        linha: tipoLabel + " · " + (s.defeito || "—") + " · programada · " + (s.agenda ? s.agenda.tecnico + " em " + s.agenda.data : "")
      };
    });
    if (items.some((it) => !it.raw || !(it.raw.serie || it.serie))) {
      this.flash("Dados do equipamento incompletos para programar");
      return;
    }
    this.setState({ gerandoOS: true });
    try {
      const filled = (v) => String(v || "").replace(/\D/g, "");
      const result = await submitSchedulePreventiveOrders({
        origem: s.origem,
        tipoOsValue: tipoOsValue || "S",
        form: {
          solicitante: s.solicitante,
          contatoFone1: s.contatoFone1,
          contatoWhatsApp: s.contatoWhatsApp,
          contatoFone2: s.contatoFone2,
          email: s.email,
          obs: s.obs,
          defeitoCodigo: s.defeitoCodigo
        },
        loc: sharedLoc,
        counters: {
          confirmed: !!(filled(s.contPb) || filled(s.contCor) || filled(s.contTotal)),
          pb: s.contPb,
          cor: s.contCor,
          total: s.contTotal
        },
        agenda: s.agenda,
        items
      });
      this.setState({
        osGeradas: result.lista,
        concluido: true,
        gerandoOS: false,
        tipoOsValue: tipoOsValue || "S",
        osOpenLocation: sharedLoc,
        preventivasProgramadas: true,
        preventivaScheduleDate: result.scheduleDate || (s.agenda && (s.agenda.dataIso || s.agenda.data)) || null
      });
    } catch (err) {
      this.flash((err && err.message) || "Erro ao programar preventivas");
      this.setState({ gerandoOS: false });
    }
  }

  emailCtxFromState(s) {
    const raw = (s.equip && s.equip.raw) || {};
    const loc = s.osOpenLocation || this.buildOpenOsLocationFields();
    const end = [loc.END_LOGRADOURO, loc.END_NUM, loc.END_BAIRRO, loc.END_CIDADE, loc.END_ESTADO].filter(Boolean).join(", ");
    const endereco = [s.endereco || end, loc.LOCALIZACAO].filter(Boolean).join(" - ");
    return {
      modelo: (s.equip && s.equip.modelo) || "",
      serie: (s.equip && s.equip.serie) || "",
      endereco: endereco,
      solicitante: s.solicitante,
      contato: s.contatoFone1 || s.contatoWhatsApp || s.contatoFone2 || "",
      defeito: s.defeito,
      obs: s.obs,
      empresaNome: raw.emp_nome || "",
      empresaCodigo: raw.codEmp || ""
    };
  }

  previsaoLabel() {
    const a = this.state.agenda;
    if (!a) return undefined;
    if (a.noCertainDate) return "Não há data certa de previsão";
    return a.data || undefined;
  }

  buildPrintOrders(filterNumero) {
    const s = this.state;
    const raw = (s.equip && s.equip.raw) || {};
    const loc = s.osOpenLocation || this.buildOpenOsLocationFields();
    const today = new Date();
    const dataAbertura = `${String(today.getDate()).padStart(2, "0")}/${String(today.getMonth() + 1).padStart(2, "0")}/${today.getFullYear()} ${String(today.getHours()).padStart(2, "0")}:${String(today.getMinutes()).padStart(2, "0")}`;
    const previsao = this.previsaoLabel();
    return (s.osGeradas || []).filter((os) => {
      if (!os || !os.success) return false;
      if (filterNumero) return String(os.numero) === String(filterNumero);
      return true;
    }).map((os) => ({
      id: os.numero,
      cliente: s.clienteLabel || raw.cliente || "",
      endereco: formatLocationLabel({
        END_LOGRADOURO: os.END_LOGRADOURO,
        END_NUM: os.END_NUM,
        END_BAIRRO: os.END_BAIRRO,
        END_CIDADE: os.END_CIDADE,
        END_ESTADO: os.END_ESTADO,
      }) || s.endereco || raw.Endereco || "",
      TB02112_LOCAL: os.LOCALIZACAO || loc.LOCALIZACAO || raw.Endereco_Local || "",
      equipamento: os.modelo || (s.equip && s.equip.modelo) || raw.produto || "",
      numeroSerie: os.serie || (s.equip && s.equip.serie) || raw.serie || "",
      patrimonio: os.patrimonio || (s.equip && s.equip.patrimonio) || raw.patrimonio || "",
      dataAbertura,
      solicitante: s.solicitante || "",
      motivoOS: s.defeito || "",
      motivoOSObservacao: s.obs || "",
      defeitoNome: s.defeito || "",
      defeitoObservacao: s.obs || "",
      tipo: s.tipoOsValue || "",
      TB01007_NOME: raw.emp_nome || "",
      TB01007_CNPJ: raw.emp_cnpj || "",
      TB01007_ENDERECO: raw.emp_endereco || "",
      site_nome: raw.site_nome || "",
      depto_nome: raw.depto_nome || "",
      previsaoLabelOverride: previsao
    }));
  }

  openPrintPreview(filterNumero) {
    const orders = this.buildPrintOrders(filterNumero);
    if (!orders.length) {
      this.flash("Nenhuma OS para imprimir");
      return;
    }
    this.setState({
      printPreview: {
        orders,
        includeHistory: orders.length === 1
      }
    });
  }

  closePrintPreview() {
    this.setState({ printPreview: null });
  }

  openEmailModal(filterNumero) {
    const oss = (this.state.osGeradas || []).filter((os) => {
      if (!os || !os.success) return false;
      if (filterNumero) return String(os.numero) === String(filterNumero);
      return true;
    });
    if (!oss.length) return;
    this.setState({
      emailModal: { numeros: oss.map((o) => o.numero) },
      emailModalList: (this.state.emails || []).slice(),
      emailModalDraft: "",
      emailSending: false,
      emailSentOk: false,
      emailSendError: ""
    });
  }

  closeEmailModal() {
    if (this.state.emailSending) return;
    this.setState({ emailModal: null, emailSentOk: false, emailSendError: "", emailModalDraft: "" });
  }

  commitEmailModalDraft() {
    const addr = String(this.state.emailModalDraft || "").trim().toLowerCase();
    if (!addr) return;
    if (!this.isEmailAddr(addr)) {
      this.setState({ emailSendError: "E-mail inválido" });
      return;
    }
    const list = (this.state.emailModalList || []).slice();
    if (list.indexOf(addr) < 0) list.push(addr);
    this.setState({ emailModalList: list, emailModalDraft: "", emailSendError: "" });
  }

  async sendEmailModal() {
    const addr = String(this.state.emailModalDraft || "").trim().toLowerCase();
    const recipients = (this.state.emailModalList || []).slice();
    if (addr) {
      if (!this.isEmailAddr(addr)) {
        this.setState({ emailSendError: "E-mail inválido" });
        return;
      }
      if (recipients.indexOf(addr) < 0) recipients.push(addr);
    }
    if (!recipients.length) {
      this.setState({ emailSendError: "Informe ao menos um e-mail" });
      return;
    }
    const modal = this.state.emailModal;
    if (!modal) return;
    const wanted = (modal.numeros || []).map(String);
    const oss = (this.state.osGeradas || []).filter((os) => wanted.indexOf(String(os.numero)) >= 0);
    this.setState({ emailSending: true, emailSendError: "", emailModalList: recipients, emailModalDraft: "" });
    try {
      await sendOpenOsAberturaEmails({
        recipients,
        osItems: oss,
        ctx: this.emailCtxFromState(this.state),
        viaSystem: false
      });
      this.setState({ emailSending: false, emailSentOk: true });
      setTimeout(() => this.setState({ emailModal: null, emailSentOk: false }), 1800);
    } catch (err) {
      this.setState({ emailSending: false, emailSendError: (err && err.message) || "Erro ao enviar email" });
    }
  }

  async loadDefeitoEquipAssocFlag() {
    const fn = typeof window !== "undefined" ? window.__openOsV2FetchDefeitoEquipAssocFlag : null;
    if (typeof fn !== "function") return;
    try {
      const enabled = await fn();
      this.setState({ defeitoEquipVinculoAtivo: !!enabled }, () => this.syncTipoOsComDefeito());
    } catch (err) {
      this.setState({ defeitoEquipVinculoAtivo: false });
    }
  }

  /** Valores de tipo permitidos pelo perfil (asstec_openos_type_only); null = sem restrição de usuário. */
  getUserRestrictedTipoValues() {
    if (!this.props.restrictOpenOsByUserTypes) return null;
    return userOsLoadFlagsToValues(this.props.userOsTypesLoad);
  }

  getAllowedTipoValues(defeito) {
    let values = getAllowedTipoValuesForAbertura(defeito, {
      restrictionActive: !!this.state.defeitoEquipVinculoAtivo,
      origem: this.state.origem || null,
    });
    const userVals = this.getUserRestrictedTipoValues();
    if (userVals) {
      values = values.filter((v) => userVals.indexOf(v) >= 0);
    }
    return values;
  }

  tipoOptionsForPicker() {
    if (this.state.defeitoEquipVinculoAtivo) {
      return CONFIG_TIPO_OS_OPTIONS.map((o) => ({ label: o.label, value: o.value }));
    }
    return TIPO_OS_OPTIONS;
  }

  defaultTipoOsValue() {
    const padrao = this.tipoLabelToValue(this.props.tipoOSPadrao || "Corretiva");
    if (this.state.origem === "estoque") return "E";
    return padrao;
  }

  tipoLabelToValue(label) {
    const o = TIPO_OS_OPTIONS.find((x) => x.label === label);
    return o ? o.value : "N";
  }

  tipoValueToLabel(value) {
    const o = TIPO_OS_OPTIONS.find((x) => x.value === value);
    if (o) return o.label;
    return TIPO_OS_VALUE_LABELS[value] || "Corretiva";
  }

  syncTipoOsComDefeito() {
    const allowed = this.getAllowedTipoValues(this.state.defeitoObj);
    const padrao = this.defaultTipoOsValue();
    let val = this.state.tipoOsValue || padrao;
    if (allowed.indexOf(val) < 0) val = allowed[0] || padrao;
    if (val !== this.state.tipoOsValue) this.setState({ tipoOsValue: val });
  }

  getEquipRawForSchedule() {
    const s = this.state;
    if (s.equip && s.equip.raw) return s.equip.raw;
    if (s.sel && s.sel.length) {
      const info = this.infoDe(s.sel[0]);
      if (info && info.raw) return info.raw;
    }
    return null;
  }

  getScheduleCalendar() {
    const fn = typeof window !== "undefined" ? window.__openOsV2ScheduleCalendar : null;
    if (typeof fn !== "function") {
      const hoje = new Date();
      const currentDay = hoje.getDay();
      const amanha = (currentDay >= 1 && currentDay <= 4)
        ? new Date(hoje.getFullYear(), hoje.getMonth(), hoje.getDate() + 1)
        : new Date(hoje.getFullYear(), hoje.getMonth(), hoje.getDate() + (currentDay === 0 ? 1 : 8 - currentDay));
      const minFut = new Date(amanha.getFullYear(), amanha.getMonth(), amanha.getDate() + 1);
      const pad = (n) => String(n).padStart(2, "0");
      const iso = (d) => d.getFullYear() + "-" + pad(d.getMonth() + 1) + "-" + pad(d.getDate());
      return {
        todayIso: iso(hoje),
        tomorrowIso: iso(amanha),
        minFutureIso: iso(minFut),
        hojeDia: pad(hoje.getDate()),
        hojeDow: DOW[hoje.getDay()],
        amanhaDia: pad(amanha.getDate()),
        amanhaDow: DOW[amanha.getDay()]
      };
    }
    return fn();
  }

  async loadScheduleAreas() {
    const fn = typeof window !== "undefined" ? window.__openOsV2LoadScheduleData : null;
    if (typeof fn !== "function") {
      this.setState({ scheduleAreasData: null, scheduleAreasLoading: false });
      return;
    }
    this.setState({ scheduleAreasLoading: true });
    try {
      let areas = await fn(this.getEquipRawForSchedule());
      const exclude = String(this.props.excludeTechnicianName || "").trim().toLowerCase();
      if (exclude && Array.isArray(areas)) {
        areas = areas
          .map((area) => ({
            ...area,
            tecnicos: (area.tecnicos || []).filter((t) => {
              const name = String(t.nome || t.name || t).trim().toLowerCase();
              return name && name !== exclude;
            }),
          }))
          .filter((a) => (a.tecnicos || []).length > 0);
      }
      this.setState({ scheduleAreasData: areas, scheduleAreasLoading: false });
    } catch (err) {
      this.setState({ scheduleAreasData: [], scheduleAreasLoading: false });
    }
  }

  clampRouteKm(raw) {
    const n = parseInt(String(raw == null ? "" : raw).replace(/\D/g, ""), 10);
    if (!Number.isFinite(n)) return 5;
    return Math.min(50, Math.max(3, n));
  }

  buildNearbyCountMap(points, km) {
    const canonical = {};
    (points || []).forEach((p) => {
      if (Number(p.km) > km) return;
      const raw = String((p && p.codTec) || "").trim();
      if (!raw) return;
      const padded = padAgendaCodTec(raw);
      if (!canonical[padded]) canonical[padded] = 0;
      canonical[padded] += 1;
    });
    const map = {};
    Object.keys(canonical).forEach((padded) => {
      const count = canonical[padded];
      map[padded] = count;
      const stripped = padded.replace(/^0+/, "") || padded;
      if (stripped !== padded) map[stripped] = count;
    });
    return map;
  }

  collectAllowedTechKeys(areas) {
    const keys = new Set();
    const add = (value) => {
      const raw = String(value == null ? "" : value).trim();
      if (!raw) return;
      keys.add(raw);
      const digits = raw.replace(/\D/g, "");
      if (!digits) return;
      const padded = digits.padStart(4, "0").slice(-4);
      const stripped = digits.replace(/^0+/, "") || padded;
      keys.add(padded);
      keys.add(stripped);
    };
    (areas || []).forEach((area) => {
      (area.tecnicos || []).forEach((t) => {
        add(t && t.id);
        add(t && t.codigo);
      });
    });
    return keys;
  }

  techKeyInSet(codTec, keys) {
    if (!keys || !keys.size) return false;
    const raw = String(codTec == null ? "" : codTec).trim();
    if (!raw) return false;
    if (keys.has(raw)) return true;
    const digits = raw.replace(/\D/g, "");
    if (!digits) return false;
    const padded = digits.padStart(4, "0").slice(-4);
    const stripped = digits.replace(/^0+/, "") || padded;
    return keys.has(padded) || keys.has(stripped);
  }

  scopeRouteHelpPoints(points, areas, hasScheduleBridge, scheduleAreasData) {
    const list = Array.isArray(points) ? points : [];
    if (!hasScheduleBridge) return list;
    if (!Array.isArray(scheduleAreasData)) return [];
    const allowed = this.collectAllowedTechKeys(areas);
    if (!allowed.size) return [];
    return list.filter((p) => this.techKeyInSet(p && p.codTec, allowed));
  }

  filterPointsForSelectedTech(points, tech) {
    if (!tech) return points;
    const keys = new Set();
    const add = (value) => {
      const raw = String(value == null ? "" : value).trim();
      if (!raw) return;
      keys.add(raw);
      const digits = raw.replace(/\D/g, "");
      if (!digits) return;
      const padded = digits.padStart(4, "0").slice(-4);
      const stripped = digits.replace(/^0+/, "") || padded;
      keys.add(padded);
      keys.add(stripped);
    };
    add(tech.id);
    add(tech.codigo);
    if (!keys.size) return points;
    return (points || []).filter((p) => this.techKeyInSet(p && p.codTec, keys));
  }

  nearbyCountForTech(t, countMap) {
    const map = countMap || this._routeHelpCountMap;
    if (!map) return 0;
    const ids = [t && t.id, t && t.codigo].filter((v) => v != null && String(v).trim() !== "");
    for (let i = 0; i < ids.length; i++) {
      const raw = String(ids[i]).trim();
      if (map[raw]) return map[raw];
      const digits = raw.replace(/\D/g, "");
      if (!digits) continue;
      const padded = digits.padStart(4, "0").slice(-4);
      const stripped = digits.replace(/^0+/, "") || padded;
      if (map[padded]) return map[padded];
      if (map[stripped]) return map[stripped];
    }
    return 0;
  }

  toggleRouteHelp() {
    const ok = this.state.quandoDraft === "hoje" || this.state.quandoDraft === "amanha";
    if (!ok) return;
    if (this.state.routeHelpOpen) {
      this.cancelarRouteHelp();
      return;
    }
    this.setState({
      routeHelpOpen: true,
      routeHelpKm: 5,
      routeHelpError: "",
      routeHelpOrigin: null,
      routeHelpPoints: [],
      routeHelpAgendaMirrorOpen: false,
      routeHelpMonitoredTechs: []
    }, () => {
      this.buscarRouteHelp();
      this.startMonitoredPoll();
    });
  }

  setRouteHelpKm(km) {
    this.setState({ routeHelpKm: this.clampRouteKm(km) });
  }

  async buscarRouteHelp() {
    const s = this.state;
    if (!s.routeHelpOpen) return;
    if (s.quandoDraft !== "hoje" && s.quandoDraft !== "amanha") return;
    const address = String(s.endereco || "").trim();
    if (!address) {
      this.setState({ routeHelpLoading: false, routeHelpError: "Endereço do atendimento não informado.", routeHelpOrigin: null, routeHelpPoints: [] });
      return;
    }
    const parsedCity = s.enderecoParsed && s.enderecoParsed.cidade;
    const raw = s.equip && s.equip.raw;
    const rawEnd = raw && raw.endereco ? raw.endereco : null;
    const boardCity = this.props.agendaOnly ? String(this.props.scheduleOriginCity || "").trim() : "";
    const city = String(
      parsedCity ||
      boardCity ||
      (rawEnd && rawEnd.cidade) ||
      (raw && (raw.Cidade || raw.cidade)) ||
      ""
    ).trim();
    this._routeHelpSeq = (this._routeHelpSeq || 0) + 1;
    const seq = this._routeHelpSeq;
    this.setState({ routeHelpLoading: true, routeHelpError: "" });
    const result = await fetchAgendaNearbyTechs({ address, day: s.quandoDraft, km: 50, city });
    if (seq !== this._routeHelpSeq) return;
    if (!result.success) {
      this.setState({ routeHelpLoading: false, routeHelpError: result.error || "Falha na busca.", routeHelpOrigin: null, routeHelpPoints: [] });
      return;
    }
    if (!result.originFound || !result.origin) {
      this.setState({ routeHelpLoading: false, routeHelpError: "Não foi possível localizar o endereço.", routeHelpOrigin: null, routeHelpPoints: [] });
      return;
    }
    this.setState({
      routeHelpLoading: false,
      routeHelpOrigin: result.origin,
      routeHelpPoints: result.points || [],
      routeHelpError: ""
    });
  }

  cancelarRouteHelp() {
    this._routeHelpSeq = (this._routeHelpSeq || 0) + 1;
    this.stopMonitoredPoll();
    this.setState({
      routeHelpOpen: false,
      routeHelpOrigin: null,
      routeHelpPoints: [],
      routeHelpError: "",
      routeHelpLoading: false,
      routeHelpAgendaMirrorOpen: false,
      routeHelpKm: 5,
      routeHelpMonitoredTechs: []
    });
  }

  stopMonitoredPoll() {
    if (this._monitoredPollTimer) {
      window.clearInterval(this._monitoredPollTimer);
      this._monitoredPollTimer = null;
    }
    this._monitoredSeq = (this._monitoredSeq || 0) + 1;
  }

  async loadMonitoredTechs() {
    if (!isGoPremium(this.props.goIdProduto)) return;
    if (!this.state.routeHelpOpen) return;
    this._monitoredSeq = (this._monitoredSeq || 0) + 1;
    const seq = this._monitoredSeq;
    const result = await fetchAgendaMonitoredLocations();
    if (seq !== this._monitoredSeq || !this.state.routeHelpOpen) return;
    if (!result.success || result.premiumRequired) {
      this.setState({ routeHelpMonitoredTechs: [] });
      return;
    }
    this.setState({ routeHelpMonitoredTechs: result.technicians || [] });
  }

  startMonitoredPoll() {
    this.stopMonitoredPoll();
    if (!isGoPremium(this.props.goIdProduto)) {
      this.setState({ routeHelpMonitoredTechs: [] });
      return;
    }
    this.loadMonitoredTechs();
    this._monitoredPollTimer = window.setInterval(() => this.loadMonitoredTechs(), MONITORED_POLL_MS);
  }

  toggleRouteHelpAgendaMirror() {
    const s = this.state;
    const allow = !!s.routeHelpOpen && !!s.tecnicoDraftObj && (s.quandoDraft === "hoje" || s.quandoDraft === "amanha");
    if (!allow) return;
    this.setState({ routeHelpAgendaMirrorOpen: !s.routeHelpAgendaMirrorOpen });
  }

  scheduleTypeFromQuando(quando) {
    if (quando === "hoje") return "today";
    if (quando === "amanha") return "tomorrow";
    if (quando === "futuro") return "future";
    if (quando === "tecnico") return "apenas_tecnico";
    return quando || null;
  }

  scheduleSearch(value) {
    clearTimeout(this._searchT);
    const q = String(value || "").replace(/\s+/g, " ").trim();
    if (q.length < 4) {
      this.setState({ apiHits: [], apiSearching: false });
      return;
    }
    this.setState({ apiSearching: true });
    this._searchT = setTimeout(() => this.fetchApiHits(q), 300);
  }

  scheduleAddressSearch(value) {
    clearTimeout(this._addrT);
    const q = String(value || "").replace(/\s+/g, " ").trim();
    if (q.length < 4) {
      this.setState({ enderecoHits: [], enderecoSearching: false });
      return;
    }
    this.setState({ enderecoSearching: true });
    this._addrT = setTimeout(() => this.fetchAddressHits(q), 500);
  }

  applyCorrectedAddressToRaw(parsed) {
    if (!parsed) return;
    const applyOne = (raw) => {
      if (!raw) return;
      raw.corrected_end_logradouro = parsed.logradouro || "";
      raw.corrected_end_num = parsed.numero || "0";
      raw.corrected_end_comp = parsed.complemento || "";
      raw.corrected_end_bairro = parsed.bairro || "";
      raw.corrected_end_cidade = parsed.cidade || "";
      raw.corrected_end_estado = parsed.estado || "";
      raw.corrected_end_cep = parsed.cep || "";
      raw.end_logradouro = parsed.logradouro || raw.end_logradouro || "";
      raw.end_num = parsed.numero || raw.end_num || "0";
      raw.end_comp = parsed.complemento || raw.end_comp || "";
      raw.end_bairro = parsed.bairro || raw.end_bairro || "";
      raw.end_cidade = parsed.cidade || raw.end_cidade || "";
      raw.end_estado = parsed.estado || raw.end_estado || "";
      raw.end_cep = parsed.cep || raw.end_cep || "";
    };
    const s = this.state;
    if (s.modo === "multipla" && Array.isArray(s.sel) && s.sel.length) {
      s.sel.forEach((serie) => {
        const info = this.infoDe(serie);
        if (info && info.raw) applyOne(info.raw);
      });
      return;
    }
    applyOne(s.equip && s.equip.raw);
  }

  buildOpenOsLocationFields(rawOverride, opts = {}) {
    const s = this.state;
    const useSharedCorrection = opts.useSharedCorrection !== false;
    const raw = rawOverride || this.resolveEquipRawForLocation() || {};
    const parsed = useSharedCorrection ? s.enderecoParsed : null;
    const localInterno = opts.localInterno != null ? opts.localInterno : s.localInterno;
    return locationFieldsFromEquipRaw(raw, { localInterno, parsed });
  }

  focusAddrInput() {
    const el = typeof document !== "undefined" ? document.querySelector(".oosv2-addr-input") : null;
    if (el && typeof el.focus === "function") el.focus();
  }

  async fetchAddressHits(q) {
    const seq = (this._addrSeq = (this._addrSeq || 0) + 1);
    const fn = typeof window !== "undefined" ? window.__openOsV2SearchAddress : null;
    let hits = [];
    try {
      if (typeof fn === "function") hits = await fn(q);
    } catch (err) {
      hits = [];
    }
    if (seq !== this._addrSeq) return;
    this.setState({ enderecoHits: Array.isArray(hits) ? hits : [], enderecoSearching: false });
  }

  async applyAddressSuggestion(hit) {
    const fn = typeof window !== "undefined" ? window.__openOsV2ResolveAddress : null;
    let item = hit;
    try {
      if (typeof fn === "function") item = await fn(hit, this.state.enderecoQuery) || hit;
    } catch (err) {
      item = hit;
    }
    const display = String((item && (item.display || item.texto)) || "").trim().toUpperCase();
    if (!display) return;
    const original = this.state.enderecoOriginal || this.state.endereco;
    const parsed = (item && item.parsed) || null;
    this.applyCorrectedAddressToRaw(parsed);
    this.setState({
      endereco: display,
      enderecoOriginal: original,
      enderecoParsed: parsed,
      enderecoQuery: "",
      enderecoHits: [],
      enderecoSearching: false,
      corrigindoEndereco: false
    });
  }

  async fetchApiHits(q) {
    const seq = (this._searchSeq = (this._searchSeq || 0) + 1);
    this.setState({ apiSearching: true });
    const fn = typeof window !== "undefined" ? window.__openOsV2Search : null;
    let hits = [];
    try {
      if (typeof fn === "function") {
        hits = await fn({
          query: q,
          mode: this.state.modo,
          origem: this.state.origem
        }) || [];
      }
    } catch (err) {
      hits = [];
    }
    if (seq !== this._searchSeq) return;
    this.setState({ apiHits: Array.isArray(hits) ? hits : [], apiSearching: false });
  }

  getCodEquipModelo() {
    const s = this.state;
    const rawFromEquip = s.equip && s.equip.raw;
    const rawFromSel = (() => {
      if (!s.sel || !s.sel.length) return null;
      const info = this.infoDe(s.sel[0]);
      return info && info.raw ? info.raw : null;
    })();
    const raw = rawFromEquip || rawFromSel;
    if (!raw) return "";
    return String(raw.codprod || raw.codProduto || raw.CODPROD || "").trim();
  }

  scheduleDefeitoSearch(value) {
    clearTimeout(this._defeitoSearchT);
    const q = String(value || "").replace(/\s+/g, " ").trim();
    const fn = typeof window !== "undefined" ? window.__openOsV2SearchDefeitos : null;
    if (typeof fn !== "function") {
      this.setState({ defeitoHits: [], defeitoSearching: false });
      return;
    }
    if (q.length < 3) {
      this.setState({ defeitoHits: [], defeitoSearching: false });
      return;
    }
    this.setState({ defeitoSearching: true });
    this._defeitoSearchT = setTimeout(() => this.fetchDefeitoHits(q), 300);
  }

  async fetchDefeitoHits(q) {
    const seq = (this._defeitoSearchSeq = (this._defeitoSearchSeq || 0) + 1);
    const fn = typeof window !== "undefined" ? window.__openOsV2SearchDefeitos : null;
    if (typeof fn !== "function") return;
    this.setState({ defeitoSearching: true });
    try {
      const hits = await fn({ search: q, codEquip: this.getCodEquipModelo() || null });
      if (seq !== this._defeitoSearchSeq) return;
      this.setState({
        defeitoHits: (Array.isArray(hits) ? hits : []).map((h) => ({
          ...h,
          has_reg_bug: h.has_reg_bug != null ? h.has_reg_bug : h.hasRegBug,
        })),
        defeitoSearching: false,
      });
    } catch (err) {
      if (seq !== this._defeitoSearchSeq) return;
      this.setState({ defeitoHits: [], defeitoSearching: false });
    }
  }

  selectDefeitoFromApi(d) {
    const nome = String((d && (d.nome || d.NOME)) || "").trim();
    const codigo = String((d && (d.codigo || d.CODIGO)) || "").trim();
    if (!nome) return;
    const defeitoObj = {
      codigo: codigo,
      nome: nome,
      allow_corrective: d.allow_corrective,
      allow_install: d.allow_install,
      allow_desinstall: d.allow_desinstall,
      allow_preventive: d.allow_preventive,
      allow_stock: d.allow_stock,
      allow_measurement: d.allow_measurement,
      allow_recharge: d.allow_recharge,
      allow_counter: d.allow_counter,
      has_reg_bug: d.has_reg_bug != null ? d.has_reg_bug : d.hasRegBug
    };
    this.setState({
      defeito: nome,
      defeitoQuery: nome,
      defeitoCodigo: codigo,
      defeitoObj: defeitoObj,
      obs: "",
      defeitoHits: [],
      defeitoSearching: false
    }, () => {
      this.syncTipoOsComDefeito();
      this.focusSoon(".oosv2-obs-textarea");
    });
  }

  async fetchGuards(series) {
    const list = (series || []).map((s) => {
      if (s && typeof s === "object") {
        return {
          serie: String(s.serie || "").trim(),
          patrimonio: String(s.patrimonio || "").trim(),
        };
      }
      return { serie: String(s || "").trim(), patrimonio: "" };
    }).filter((x) => x.serie);
    if (!list.length) return null;
    const osNumbers = [];
    const osAbertas = []; // { serie, patrimonio, osNumber }
    const retiradas = []; // { serie, codigo }
    const reincidencias = []; // { serie, osNumber, closedAt }
    const seenOs = {};
    const seenOsItem = {};
    const seenRet = {};
    await Promise.all(list.map(async (item) => {
      const serie = item.serie;
      const info = this.infoDe(serie);
      const patrimonio = item.patrimonio
        || (info && info.patrimonio && info.patrimonio !== "—" ? info.patrimonio : "")
        || (this.state.equip && this.state.equip.serie === serie ? (this.state.equip.patrimonio || "") : "")
        || "—";
      const [openResult, retiradaResult] = await Promise.all([
        checkOpenOS(serie),
        checkRetiradaAtivaAbertura(serie)
      ]);
      (openResult && openResult.osNumbers ? openResult.osNumbers : []).forEach((n) => {
        const num = String(n);
        if (!seenOs[num]) { seenOs[num] = true; osNumbers.push(n); }
        const ik = serie + "::" + num;
        if (!seenOsItem[ik]) {
          seenOsItem[ik] = true;
          osAbertas.push({ serie, patrimonio, osNumber: n });
        }
      });
      (retiradaResult && retiradaResult.codigos ? retiradaResult.codigos : []).forEach((c) => {
        const codigo = String(c);
        const k = serie + "::" + codigo;
        if (!seenRet[k]) {
          seenRet[k] = true;
          retiradas.push({ serie, codigo });
        }
      });
      if (openResult && openResult.recurrence) {
        reincidencias.push({ serie, ...openResult.recurrence });
      }
    }));
    if (!osNumbers.length && !retiradas.length && !reincidencias.length) return null;
    return {
      osNumbers,
      osAbertas,
      retiradas,
      reincidencias,
      // legado / fallback de exibição
      retiradaCodigos: retiradas.map((r) => r.codigo),
    };
  }

  async ensureGuards(series, onContinue) {
    if (this.state.guardChecking || this.state.guardAlert) return false;
    this.setState({ guardChecking: true });
    try {
      const alert = await this.fetchGuards(series);
      if (alert) {
        this._guardContinue = onContinue;
        this.setState({ guardAlert: alert, guardChecking: false });
        return false;
      }
    } catch (err) {
      /* segue o fluxo se a checagem falhar */
    }
    this.setState({ guardChecking: false });
    return true;
  }

  continuarGuard() {
    const fn = this._guardContinue;
    this._guardContinue = null;
    this.setState({ guardAlert: null }, () => { if (typeof fn === "function") fn(); });
  }

  cancelarGuard() {
    this._guardContinue = null;
    // Não fecha o Abrir OS: só remove o aviso e mantém a tela de trás.
    const patch = { guardAlert: null, guardChecking: false };
    if (this.state.modo === "multipla" && !this.isEstoqueMultipla()) {
      patch.step = 1; // seleção de equipamentos por local
    }
    this.setState(patch);
  }

  closeContratoVencModal() {
    this.setState({ contratoVencModal: null });
  }

  /** Modal informativo se TB02111_VENCCONTR ≤ 30 dias (ou já vencido). */
  contratoVencModalFromRaw(raw) {
    return getContractExpiryWarning(raw && raw.contr_venc);
  }

  contratoVencModalFromSeries(series) {
    const list = Array.isArray(series) ? series : [];
    for (let i = 0; i < list.length; i += 1) {
      const info = this.infoDe(list[i]);
      const warn = this.contratoVencModalFromRaw(info && info.raw);
      if (warn) return warn;
    }
    return null;
  }

  verOsGuard(num) {
    if (typeof this.props.onViewOs === "function") this.props.onViewOs(num, { source: "open" });
  }

  async selectEquipFromApi(h) {
    if (this.state.guardChecking || this.state.guardAlert) return;
    const serie = String((h && (h.serie || (h.raw && h.raw.serie))) || "").trim();
    const apply = () => this.applySelectEquipFromApi(h);
    if (serie) {
      const ok = await this.ensureGuards([{ serie, patrimonio: h && h.patrimonio }], apply);
      if (!ok) return;
    }
    apply();
  }

  async applySelectEquipFromApi(h) {
    const mapFn = typeof window !== "undefined" ? window.__openOsV2MapEquip : null;
    const mapped = typeof mapFn === "function" ? mapFn(h && h.raw) : null;
    const equip = mapped && mapped.equip ? mapped.equip : {
      serie: h.serie,
      patrimonio: h.patrimonio,
      modelo: h.modelo,
      instalado: h.instalado || "—",
      raw: h.raw || null
    };
    this.setState({
      equip: equip,
      clienteLabel: mapped ? mapped.clienteLabel : "",
      endereco: mapped ? mapped.endereco : "",
      enderecoOriginal: mapped ? mapped.endereco : "",
      enderecoParsed: null,
      enderecoHits: [],
      enderecoSearching: false,
      corrigindoEndereco: false,
      localInterno: mapped ? mapped.localInterno : "",
      contratoVencidoFlag: mapped ? !!mapped.contratoVencido : false,
      contratoVencModal: this.contratoVencModalFromRaw(equip.raw || (h && h.raw)),
      recentOsModal: null,
      step: 1,
      query: h.titulo || (equip.serie + (equip.patrimonio ? " • " + equip.patrimonio : "")),
      apiHits: [],
      ultimoLive: null,
      temUltimo: false,
      histLive: null,
      histLoading: false,
      histPeriodMonths: 24,
      periodoAberto: false,
      ultimoAberto: false,
      defeitoDetalheAberto: false,
      laudoAberto: false
    });
    const serieFetch = equip.serie;
    const fetchLast = typeof window !== "undefined" ? window.__openOsV2FetchLastOs : null;
    if (serieFetch && typeof fetchLast === "function") {
      try {
        const ultimo = await fetchLast(serieFetch);
        if (ultimo && this.state.equip && this.state.equip.serie === serieFetch) {
          const dias = ultimo.diasDesdeAbertura;
          const recent = Number.isFinite(dias) && dias >= 0 && dias <= 30;
          this.setState({
            ultimoLive: ultimo,
            temUltimo: true,
            ultimoAberto: false,
            recentOsModal: recent ? { os: ultimo.os, dateLabel: ultimo.data, dias } : null,
          });
        }
      } catch (err) {
        /* mantém UI sem histórico */
      }
    }
    this.loadHistoryFromApi(serieFetch, equip.instalado);
  }

  async loadHistoryFromApi(serie, installDate) {
    const fetchHist = typeof window !== "undefined" ? window.__openOsV2FetchHistory : null;
    if (!serie || typeof fetchHist !== "function") return;
    const months = [3, 6, 12, 24].includes(Number(this.state.histPeriodMonths))
      ? Number(this.state.histPeriodMonths)
      : 24;
    this.setState({ histLoading: true, periodoAberto: false });
    try {
      const hist = await fetchHist(serie, { installDate, months });
      if (this.state.equip && this.state.equip.serie === serie) {
        this.setState({ histLive: hist || null, histLoading: false });
      }
    } catch (err) {
      if (this.state.equip && this.state.equip.serie === serie) {
        this.setState({ histLive: null, histLoading: false });
      }
    }
  }

  setHistPeriodMonths(months) {
    const next = [3, 6, 12, 24].includes(Number(months)) ? Number(months) : 24;
    if (next === this.state.histPeriodMonths && this.state.histLive) {
      this.setState({ periodoAberto: false });
      return;
    }
    this.setState({ histPeriodMonths: next, periodoAberto: false }, () => {
      const serie = this.getEquipSerie();
      const instalado = this.state.equip && this.state.equip.instalado;
      if (serie) this.loadHistoryFromApi(serie, instalado);
    });
  }

  getEquipSerie() {
    const s = this.state;
    if (s.equip && s.equip.serie) return String(s.equip.serie).trim();
    if (s.sel && s.sel.length) return String(s.sel[0]).trim();
    return "";
  }

  formatCounterMask(value) {
    if (value == null || value === "") return "";
    const numStr = String(value).replace(/[^0-9]/g, "");
    if (!numStr) return "";
    return numStr.replace(/\B(?=(\d{3})+(?!\d))/g, ".");
  }

  removeCounterMask(value) {
    return String(value || "").replace(/[^0-9]/g, "");
  }

  async loadContadoresFromApi() {
    const serie = this.getEquipSerie();
    const fn = typeof window !== "undefined" ? window.__openOsV2FetchCounters : null;
    if (!serie || typeof fn !== "function") {
      this.setState({ lastContPb: 0, lastContCor: 0, lastContTotal: 0, contadoresLoading: false });
      return;
    }
    this.setState({ contadoresLoading: true });
    try {
      const data = await fn(serie);
      const pb = data && data.ContadorPB != null ? Number(data.ContadorPB) : 0;
      const cor = data && data.ContadorCor != null ? Number(data.ContadorCor) : 0;
      const total = data && data.ContadorTotal != null ? Number(data.ContadorTotal) : 0;
      this.setState({
        lastContPb: Number.isNaN(pb) ? 0 : pb,
        lastContCor: Number.isNaN(cor) ? 0 : cor,
        lastContTotal: Number.isNaN(total) ? 0 : total,
        contadoresLoading: false
      });
    } catch (err) {
      this.setState({ lastContPb: 0, lastContCor: 0, lastContTotal: 0, contadoresLoading: false });
    }
  }

  async toggleContadores() {
    if (this.state.contadoresAberto) {
      this.setState({ contadoresAberto: false });
      return;
    }
    this.setState({ contadoresAberto: true, contPb: "", contCor: "", contTotal: "" });
    await this.loadContadoresFromApi();
  }

  setContadorMasked(key, rawValue) {
    const masked = this.formatCounterMask(rawValue);
    if (key === "pb") this.setState({ contPb: masked });
    else if (key === "cor") this.setState({ contCor: masked });
    else if (key === "total") this.setState({ contTotal: masked });
  }

  getTb02112Context() {
    const s = this.state;
    if (s.modo === "multipla") {
      const codigo = s.cliente && (s.cliente.codigo || (s.cliente.raw && s.cliente.raw.codigo));
      const serie = s.sel && s.sel.length ? s.sel[0] : "";
      if (!serie || !codigo) return null;
      return { serie: String(serie).trim(), contrato: String(codigo).trim() };
    }
    const eq = s.equip;
    if (!eq || !eq.serie) return null;
    const raw = eq.raw || {};
    const contrato = String(raw.codigo || "").trim();
    if (!contrato) return null;
    return { serie: String(eq.serie).trim(), contrato };
  }

  tb02112Btn(key, tip) {
    const s = this.state;
    const loading = (s.tb02112Loading || {})[key];
    const ctx = this.getTb02112Context();
    let filled = false;
    if (key === "solicitante") filled = String(s.solicitante || "").trim() !== "";
    else if (key === "contato") filled = this.phoneDigits(s[this.phoneKey(s.tipoContato)]) > 0;
    else if (key === "email") filled = (s.emails || []).length > 0;
    const disabled = !ctx || !ctx.serie || !ctx.contrato || filled;
    const confirmed = filled;
    return {
      pick: () => { if (filled) return; this.tb02112Autofill(key); },
      tip: tip,
      className: "oosv2-tb02112-btn" + (key === "email" ? " oosv2-tb02112-btn--email" : "") +
        (confirmed ? " is-confirmed is-locked" : "") + (loading ? " is-loading" : "") + (disabled && !filled ? " is-disabled" : ""),
      showCheck: confirmed,
      showBook: !confirmed
    };
  }

  async tb02112Autofill(key) {
    const s = this.state;
    if (key === "solicitante" && String(s.solicitante || "").trim()) return;
    if (key === "contato" && this.phoneDigits(s[this.phoneKey(s.tipoContato)]) > 0) return;
    if (key === "email" && (s.emails || []).length > 0) return;
    const ctx = this.getTb02112Context();
    if (!ctx || !ctx.serie || !ctx.contrato) {
      this.flash("Equipamento/contrato não disponível");
      return;
    }
    const loading = this.state.tb02112Loading || {};
    if (loading[key]) return;
    const apiField = key === "solicitante" ? "SOLICITANTE" : key === "contato" ? "CONTATO" : "EMAIL";
    const fn = typeof window !== "undefined" ? window.__openOsV2FetchTB02112Field : null;
    if (typeof fn !== "function") return;
    this.setState({ tb02112Loading: Object.assign({}, loading, { [key]: true }) });
    try {
      const result = await fn(ctx.serie, ctx.contrato, apiField);
      const value = result && result.value;
      if (value != null && String(value).trim() !== "") {
        const nextLoading = Object.assign({}, this.state.tb02112Loading, { [key]: false });
        if (key === "solicitante") {
          this.setState({ solicitante: String(value).trim(), tb02112Loading: nextLoading });
        } else if (key === "contato") {
          this.setState({
            tipoContato: "Fone1",
            contatoFone1: this.maskPhone(String(value)),
            tb02112Loading: nextLoading
          });
        } else if (key === "email") {
          const addr = String(value).trim().toLowerCase();
          if (this.isEmailAddr(addr)) {
            const emails = (this.state.emails || []).slice();
            if (emails.indexOf(addr) < 0) emails.push(addr);
            this.setState({ emails: emails, emailDraft: "", email: emails.join(";"), tb02112Loading: nextLoading });
          } else {
            this.setState({ tb02112Loading: nextLoading });
          }
        }
      } else {
        this.setState({ tb02112Loading: Object.assign({}, this.state.tb02112Loading, { [key]: false }) });
        this.flash("Campo não encontrado no cadastro");
      }
    } catch (err) {
      this.setState({ tb02112Loading: Object.assign({}, this.state.tb02112Loading, { [key]: false }) });
    }
  }

  flash(t) {
    this.setState({ toast: t });
    clearTimeout(this._t);
    this._t = setTimeout(() => this.setState({ toast: "" }), 2200);
  }

  toggleIn(key, v) {
    const arr = this.state[key];
    this.setState({ [key]: arr.indexOf(v) >= 0 ? arr.filter(x => x !== v) : arr.concat([v]) });
  }

  setSerie(list, on) {
    const cur = this.state.sel.slice();
    const newly = [];
    list.forEach(s => {
      const i = cur.indexOf(s);
      if (on && i < 0) {
        cur.push(s);
        newly.push(s);
      }
      if (!on && i >= 0) cur.splice(i, 1);
    });
    const patch = { sel: cur, endereco: "", corrigindoEndereco: false };
    if (on && newly.length) {
      const warn = this.contratoVencModalFromSeries(newly);
      if (warn) patch.contratoVencModal = warn;
    }
    this.setState(patch);
  }

  async selectClienteFromApi(h) {
    const codigo = contractCodigoFromHit(h);
    const cliente = {
      codigo: codigo,
      nome: (h && (h.nome || h.classif)) || "",
      classif: (h && (h.classif || h.nome)) || "",
      raw: (h && h.raw) || null
    };
    this.setState({
      cliente: cliente,
      query: ((h && h.titulo) || "") + ((h && h.sub) ? " " + h.sub : ""),
      apiHits: [],
      apiSearching: true,
      locaisLive: [],
      abertosLocais: [],
      abertosModelos: [],
      sel: [],
      step: 1
    });
    if (!codigo) {
      this.setState({ apiSearching: false });
      return;
    }
    try {
      const result = await getContractEquipment(codigo);
      const locais = mapContractEquipmentToLocais((result && result.equipment) || []);
      this.setState({
        locaisLive: locais,
        abertosLocais: [],
        apiSearching: false
      });
    } catch (err) {
      this.setState({ apiSearching: false });
    }
  }

  getLocais() {
    return Array.isArray(this.state.locaisLive) ? this.state.locaisLive : [];
  }

  toggleEstoqueEquipFromApi(h) {
    const serie = String((h && h.serie) || "").trim();
    if (!serie) return;
    const mapFn = typeof window !== "undefined" ? window.__openOsV2MapEquip : null;
    const mapped = typeof mapFn === "function" ? mapFn(h && h.raw) : null;
    const curMap = Object.assign({}, this.state.selEstoqueBySerie || {});
    const sel = this.state.sel.slice();
    const idx = sel.indexOf(serie);
    if (idx >= 0) {
      sel.splice(idx, 1);
      delete curMap[serie];
      this.setState({ sel, selEstoqueBySerie: curMap });
      return;
    }
    const info = {
      serie,
      patrimonio: (h && h.patrimonio) || "",
      modelo: (h && h.modelo) || "—",
      instalado: (h && h.instalado) || "—",
      local: "Estoque",
      endereco: mapped ? mapped.endereco : formatSiteAddressFromRaw(h && h.raw),
      raw: (h && h.raw) || null
    };
    curMap[serie] = info;
    sel.push(serie);
    const patch = { sel, selEstoqueBySerie: curMap };
    if (sel.length === 1 && mapped) {
      patch.clienteLabel = mapped.clienteLabel || "";
      patch.endereco = mapped.endereco || "";
      patch.enderecoOriginal = mapped.endereco || "";
      patch.localInterno = mapped.localInterno || "";
      patch.contratoVencidoFlag = !!mapped.contratoVencido;
    }
    const warn = this.contratoVencModalFromRaw(info.raw);
    if (warn) patch.contratoVencModal = warn;
    this.setState(patch);
  }

  removeEstoqueSel(serie) {
    const key = String(serie || "").trim();
    if (!key) return;
    const curMap = Object.assign({}, this.state.selEstoqueBySerie || {});
    delete curMap[key];
    this.setState({
      sel: this.state.sel.filter((x) => x !== key),
      selEstoqueBySerie: curMap
    });
  }

  infoDe(serie) {
    const est = (this.state.selEstoqueBySerie || {})[serie];
    if (est) return est;
    let found = null;
    this.getLocais().forEach(l => l.modelos.forEach(m => m.series.forEach(s => {
      if (s.serie === serie) {
        found = {
          serie: s.serie,
          patrimonio: s.patrimonio,
          modelo: m.nome,
          local: l.nome,
          endereco: l.endereco || formatSiteAddressFromRaw(s.raw),
          raw: s.raw || null
        };
      }
    })));
    return found || { serie: serie, patrimonio: "—", modelo: "—", local: "—" };
  }

  alertaChipStyle(raw) {
    let s = String(raw || "").trim();
    if (s && s.charAt(0) !== "#") s = "#" + s;
    if (!/^#[0-9a-fA-F]{6}$/i.test(s)) s = "#8458fe";
    const r = parseInt(s.slice(1, 3), 16);
    const g = parseInt(s.slice(3, 5), 16);
    const b = parseInt(s.slice(5, 7), 16);
    const lum = (0.299 * r + 0.587 * g + 0.114 * b) / 255;
    return "background-color:" + s + ";color:" + (lum > 0.55 ? "#0f172a" : "#fff");
  }

  phoneKey(tipo) {
    if (tipo === "WhatsApp") return "contatoWhatsApp";
    if (tipo === "Fone2") return "contatoFone2";
    return "contatoFone1";
  }

  maskPhone(value) {
    const n = String(value || "").replace(/\D/g, "").slice(0, 11);
    if (!n.length) return "";
    if (n.length <= 2) return "(" + n;
    if (n.length <= 6) return "(" + n.slice(0, 2) + ")" + n.slice(2);
    if (n.length <= 10) return "(" + n.slice(0, 2) + ")" + n.slice(2, 6) + "-" + n.slice(6);
    return "(" + n.slice(0, 2) + ")" + n.slice(2, 7) + "-" + n.slice(7);
  }

  phoneDigits(value) {
    return String(value || "").replace(/\D/g, "").length;
  }

  isEmailAddr(value) {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/i.test(String(value || "").trim());
  }

  applyEmailInput(text) {
    const MAX = 200;
    let emails = (this.state.emails || []).slice();
    const roomFor = (addr) => emails.concat([addr]).join(";").length <= MAX;
    const raw = String(text || "");
    if (!/[\s,;]/.test(raw)) {
      const prefix = emails.length ? emails.join(";").length + 1 : 0;
      const draft = raw.slice(0, Math.max(0, MAX - prefix));
      this.setState({
        emailDraft: draft,
        email: emails.concat(draft.trim() ? [draft.trim()] : []).join(";")
      });
      return;
    }
    const bits = raw.split(/[\s,;]+/);
    const trailing = /[\s,;]$/.test(raw);
    let draft = trailing ? "" : (bits.pop() || "");
    bits.forEach((b) => {
      const addr = b.trim().toLowerCase();
      if (this.isEmailAddr(addr) && emails.indexOf(addr) < 0 && roomFor(addr)) emails.push(addr);
    });
    const prefix = emails.length ? emails.join(";").length + 1 : 0;
    draft = draft.slice(0, Math.max(0, MAX - prefix));
    this.setState({
      emails: emails,
      emailDraft: draft,
      email: emails.concat(draft.trim() ? [draft.trim()] : []).join(";")
    });
  }

  commitEmailDraft() {
    const addr = String(this.state.emailDraft || "").trim().toLowerCase();
    if (!addr || !this.isEmailAddr(addr)) return;
    const emails = (this.state.emails || []).slice();
    if (emails.indexOf(addr) < 0 && emails.concat([addr]).join(";").length <= 200) emails.push(addr);
    this.setState({ emails: emails, emailDraft: "", email: emails.join(";") });
  }

  renderVals() {
    const s = this.state;
    if (typeof window !== "undefined") {
      window.__openOsV2SetFutureDate = (ymd) => {
        const v = String(ymd || "").trim();
        if (v) {
          const cal = this.getScheduleCalendar();
          if (cal && cal.minFutureIso && v < cal.minFutureIso) return;
        }
        this.setState({ dataDraft: v, semPrevisao: v ? false : this.state.semPrevisao });
      };
      window.__openOsV2AppendStandbyNotes = (text) => {
        const add = String(text || "").trim();
        if (!add) return;
        const cur = String(this.state.standbyNotes || "").trim();
        this.setState({ standbyNotes: cur ? (cur + " " + add) : add });
      };
      window.__openOsV2GetObs = () => String(this.state.obs || "");
      window.__openOsV2SetObs = (text) => {
        this.setState({ obs: String(text || "") });
      };
      window.__openOsV2AppendObs = (text) => {
        const add = String(text || "").trim();
        if (!add) return;
        const cur = String(this.state.obs || "").trim();
        this.setState({ obs: cur ? (cur + " " + add) : add });
      };
    }
    const tipoPadraoVal = this.defaultTipoOsValue();
    const allowedTipos = this.getAllowedTipoValues(s.defeitoObj);
    const mostrarTiposOs = !!s.defeitoEquipVinculoAtivo && !!s.defeitoObj && allowedTipos.length > 0;
    let tipoOsValue = s.tipoOsValue || tipoPadraoVal;
    if (allowedTipos.indexOf(tipoOsValue) < 0) tipoOsValue = allowedTipos[0] || tipoPadraoVal;
    const tipoOS = this.tipoValueToLabel(tipoOsValue);
    const exigirEmail = this.props.exigirEmail === true;
    const isMultipla = s.modo === "multipla";
    const isEstoqueMultipla = this.isEstoqueMultipla(s);

    const fluxo = this.fluxoSteps(s);
    const idx = Math.min(s.step, fluxo.length - 1);
    const atual = fluxo[idx];
    const concluido = s.concluido;

    const selInfos = s.sel.map(x => this.infoDe(x));
    const totalSelecionado = isMultipla ? s.sel.length : (s.equip ? 1 : 0);

    const solicitanteOk = s.solicitante.trim().length >= 3;
    const fone1Ok = this.phoneDigits(s.contatoFone1) >= 10;
    const whatsOk = this.phoneDigits(s.contatoWhatsApp) >= 10;
    const fone2Ok = this.phoneDigits(s.contatoFone2) >= 10;
    const contatoOk = fone1Ok || whatsOk || fone2Ok;
    const emailDraft = String(s.emailDraft || "").trim();
    const emailDraftOk = !emailDraft || this.isEmailAddr(emailDraft);
    const emailOk = emailDraftOk && (!exigirEmail || (s.emails || []).length > 0 || this.isEmailAddr(emailDraft));
    const form1Ok = solicitanteOk && contatoOk && emailOk;
    const defeitoOk = !!s.defeito && s.obs.trim().length >= 15
      && (!mostrarTiposOs || (tipoOsValue && allowedTipos.indexOf(tipoOsValue) >= 0));

    const faltas1 = [];
    if (!solicitanteOk) faltas1.push("solicitante");
    if (!contatoOk) faltas1.push("contato");
    if (!emailOk) faltas1.push("e-mail");

    const rotulos = {
      equip: { label: "Equipamento", hint: s.equip ? s.equip.serie : (isEstoqueMultipla && s.sel.length ? s.sel.length + " equipamentos" : (s.cliente ? s.cliente.codigo : "Origem e busca")) },
      sel: { label: "Seleção", hint: s.sel.length ? s.sel.length + " equipamentos" : "Locais e séries" },
      conf: { label: "Confirmação", hint: form1Ok ? s.solicitante : "Dados e solicitante" },
      defeito: { label: "Defeito", hint: s.defeito || "Defeito e observação" },
      fim: { label: "Finalizar", hint: tipoOS }
    };

    const trilha = fluxo.map((k, i) => {
      const done = concluido || s.step > i;
      const ativo = !concluido && s.step === i;
      const clicavel = i < s.step && !concluido;
      return {
        label: rotulos[k].label, hint: rotulos[k].hint, num: String(i + 1), done: done, pending: !done, editavel: clicavel,
        go: () => { if (clicavel) this.setState({ step: i }); },
        stepClass: "oosv2-flow-step" + (ativo ? " is-active" : "") + (done && !ativo ? " is-done" : "") + (clicavel ? " is-editable" : ""),
        wrapStyle: "border-radius:12px;min-width:0;" + (clicavel ? "cursor:pointer" : "cursor:default"),
        innerStyle: "display:flex;align-items:center;gap:9px;padding:7px 9px;border-radius:10px;min-width:0;transition:background .15s;" +
          (ativo ? "background:#f4f1ff;" : "background:transparent;"),
        dotStyle: "width:20px;height:20px;border-radius:7px;display:flex;align-items:center;justify-content:center;font-size:10.5px;font-weight:700;flex:0 0 auto;" +
          (done ? "background:#12a45a;color:#fff" : ativo ? "background:#6d3ef5;color:#fff" : "background:#f0f0f5;color:#a0a0b2"),
        labelStyle: "font-size:12px;font-weight:700;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;" + (ativo || done ? "color:#16161d" : "color:#8a8a9e")
      };
    });

    const origens = [
      { key: "contrato", label: "Contrato", desc: "Contrato ativo", kbd: "1" },
      { key: "estoque", label: "Estoque", desc: "Estoque interno", kbd: "2" }
    ].map(o => ({
      label: o.label, desc: o.desc, kbd: o.kbd,
      pick: () => this.pickOrigem(o.key),
      choiceClass: "oosv2-choice" + (s.origem === o.key ? " is-on" : "")
    }));

    const modos = [
      { key: "unica", label: "OS única", desc: "Um por série/patrimônio", kbd: "1" },
      { key: "multipla", label: "OS múltipla", desc: "Vários do mesmo cliente", kbd: "2" }
    ].map(m => ({
      label: m.label, desc: m.desc, kbd: m.kbd,
      pick: () => this.pickModo(m.key),
      choiceClass: "oosv2-choice" + (s.modo === m.key ? " is-on" : ""),
      dotClass: "oosv2-choice-dot" + (s.modo === m.key ? " is-on" : "")
    }));

    const q = s.query.trim().toUpperCase();
    let resultados = [];
    if (s.modo === "unica" && q.length >= 4) {
      resultados = (s.apiHits || []).filter(h => h && h.kind === "equip").map(h => ({
        titulo: h.titulo, sub: h.sub, tag: s.origem === "estoque" ? "Estoque" : (h.tag || "Contrato"),
        pick: () => this.selectEquipFromApi(h)
      }));
    } else if (isEstoqueMultipla && q.length >= 4) {
      resultados = (s.apiHits || []).filter(h => h && h.kind === "equip").map(h => {
        const marcado = s.sel.indexOf(h.serie) >= 0;
        return {
          titulo: h.titulo,
          sub: h.sub,
          tag: "Estoque",
          marcado,
          rowClass: "oosv2-search-result-row" + (marcado ? " is-selected" : ""),
          pick: () => this.toggleEstoqueEquipFromApi(h)
        };
      });
    } else if (isMultipla && q.length >= 4 && !s.cliente) {
      resultados = (s.apiHits || []).filter(h => h && h.kind === "cliente").map(h => ({
        titulo: h.titulo, sub: h.sub, tag: "Cliente",
        pick: () => this.selectClienteFromApi(h)
      }));
    }

    const f = s.filtro.trim().toUpperCase();
    const arvoreDados = this.getLocais().map(l => {
      const modelos = l.modelos.map(m => {
        const series = m.series.filter(sr => !f || (sr.serie + " " + sr.patrimonio).toUpperCase().indexOf(f) >= 0 || m.nome.toUpperCase().indexOf(f) >= 0 || l.nome.toUpperCase().indexOf(f) >= 0);
        return { nome: m.nome, series: series };
      }).filter(m => m.series.length > 0);
      return { nome: l.nome, modelos: modelos, endereco: l.endereco || "" };
    }).filter(l => l.modelos.length > 0);

    const arvore = arvoreDados.map(l => {
      const todas = [];
      l.modelos.forEach(m => m.series.forEach(x => todas.push(x.serie)));
      const marcadas = todas.filter(x => s.sel.indexOf(x) >= 0).length;
      const marcado = todas.length > 0 && marcadas === todas.length;
      const abertoL = s.abertosLocais.indexOf(l.nome) >= 0;
      return {
        nome: l.nome, endereco: l.endereco || "", contagem: todas.length + " equipamentos", aberto: abertoL, marcado: marcado,
        selecionadosTexto: marcadas > 0 ? marcadas + " sel." : "",
        badgeClass: marcadas > 0 ? "oosv2-selecao-local-badge" : "oosv2-selecao-local-badge is-hidden",
        toggle: () => this.toggleIn("abertosLocais", l.nome),
        check: (e) => { e.stopPropagation(); this.setSerie(todas, !marcado); },
        boxClass: "oosv2-selecao-check" + (marcado ? " is-on" : ""),
        caretClass: "oosv2-selecao-caret" + (abertoL ? " is-open" : ""),
        modelos: l.modelos.map(m => {
          const ms = m.series.map(x => x.serie);
          const mMarcado = ms.every(x => s.sel.indexOf(x) >= 0);
          const key = l.nome + "|" + m.nome;
          const abertoM = s.abertosModelos.indexOf(key) >= 0;
          return {
            nome: m.nome, contagem: ms.length + " séries", aberto: abertoM, marcado: mMarcado,
            toggle: () => this.toggleIn("abertosModelos", key),
            check: (e) => { e.stopPropagation(); this.setSerie(ms, !mMarcado); },
            boxClass: "oosv2-selecao-check" + (mMarcado ? " is-on" : ""),
            caretClass: "oosv2-selecao-caret is-sub" + (abertoM ? " is-open" : ""),
            series: m.series.map(sr => {
              const on = s.sel.indexOf(sr.serie) >= 0;
              return {
                serie: sr.serie, patrimonio: sr.patrimonio, marcado: on,
                check: () => this.setSerie([sr.serie], !on),
                boxClass: "oosv2-selecao-check" + (on ? " is-on" : ""),
                rowClass: "oosv2-selecao-serie-row" + (on ? " is-selected" : "")
              };
            })
          };
        })
      };
    });

    const locaisSelecionados = [];
    selInfos.forEach(i => { if (locaisSelecionados.indexOf(i.local) < 0) locaisSelecionados.push(i.local); });
    const mesmoSiteMultipla = isMultipla && locaisSelecionados.length === 1;
    const mesmoEnderecoMultipla = isMultipla && this.selectedHaveSameAddress(selInfos);
    const mostrarUltimoConf = !isMultipla || mesmoSiteMultipla;
    let enderecoCompartilhado = "";
    if (!isMultipla) {
      enderecoCompartilhado = formatSiteAddressFromRaw(s.equip && s.equip.raw) || "";
    } else if (mesmoEnderecoMultipla) {
      enderecoCompartilhado = (selInfos[0] && selInfos[0].endereco)
        || formatSiteAddressFromRaw(selInfos[0] && selInfos[0].raw)
        || "";
    }
    const enderecoAtual = (s.endereco && String(s.endereco).trim())
      ? s.endereco
      : (isMultipla ? (enderecoCompartilhado || "") : (enderecoCompartilhado || "—"));
    const mostrarEnderecoConf = isMultipla
      ? (mesmoEnderecoMultipla && !!String(enderecoAtual || "").trim())
      : true;

    const dq = s.defeitoQuery.trim();
    const hasDefeitoBridge = typeof window !== "undefined" && typeof window.__openOsV2SearchDefeitos === "function";
    let defeitosFiltrados = [];
    const userTipoRestrict = this.getUserRestrictedTipoValues();
    if (hasDefeitoBridge) {
      defeitosFiltrados = (s.defeitoHits || [])
        .filter((d) => {
          if (!isDefeitoAllowedForAbertura(d, s.origem, s.defeitoEquipVinculoAtivo)) return false;
          // Com vínculo defeito↔tipo ativo: só defeitos que tenham ao menos um tipo permitido ao usuário
          if (userTipoRestrict && s.defeitoEquipVinculoAtivo) {
            let defectTipos = getConfigTipoValuesForDefeito(d);
            if (s.origem === 'contrato') defectTipos = defectTipos.filter((v) => v !== 'E');
            return defectTipos.some((t) => userTipoRestrict.indexOf(t) >= 0);
          }
          return true;
        })
        .map((d) => ({
        nome: d.nome || d.NOME || String(d),
        badges: getDefeitoTipoBadges(d, {
          allowedValues: userTipoRestrict && s.defeitoEquipVinculoAtivo ? userTipoRestrict : null,
        }),
        pick: () => this.selectDefeitoFromApi(d)
      }));
    } else if (dq.length >= 3) {
      const uq = dq.toUpperCase();
      defeitosFiltrados = DEFEITOS.filter(d => d.indexOf(uq) >= 0).map(d => ({
        nome: d,
        pick: () => this.setState({ defeito: d, defeitoQuery: d, defeitoCodigo: "", obs: "", defeitoHits: [] }, () => this.focusSoon(".oosv2-obs-textarea"))
      }));
    }
    const mostrarDefeitos = dq.length >= 3 && !s.defeito && defeitosFiltrados.length > 0;

    const cal = this.getScheduleCalendar();
    const amanhaParts = { dia: cal.amanhaDia, dow: cal.amanhaDow };
    const fmtIso = (iso) => {
      if (!iso) return "";
      const p = String(iso).split("-");
      return p.length === 3 ? p[2] + "/" + p[1] + "/" + p[0] : "";
    };
    const cardQuando = (key) => {
      const on = s.quandoDraft === key;
      return QUANDO_BASE + (on ? "border:1.5px solid #6d3ef5;background:#faf8ff;color:#5a2ee0;box-shadow:0 1px 4px rgba(109,62,245,.18)" : "border:1.5px solid #ececf3;background:#fff;color:#5c5c70");
    };
    const diaStyle = (key) => "font-size:22px;font-weight:700;line-height:1;font-family:'JetBrains Mono',monospace;" + (s.quandoDraft === key ? "color:#5a2ee0" : "color:#16161d");
    const dowStyle = (key) => "font-size:10px;font-weight:700;letter-spacing:.08em;" + (s.quandoDraft === key ? "color:#8a7ad0" : "color:#a0a0b2");
    const iconStyle = (key) => "width:28px;height:28px;display:flex;align-items:center;justify-content:center;border-radius:9px;margin-bottom:2px;" + (s.quandoDraft === key ? "background:#eee8ff;color:#5a2ee0" : "background:#f5f5f9;color:#8a8a9e");

    const dataDoDraft = s.quandoDraft === "hoje"
      ? fmtIso(cal.todayIso)
      : s.quandoDraft === "amanha"
        ? fmtIso(cal.tomorrowIso)
        : s.quandoDraft === "futuro"
          ? (s.semPrevisao ? "Não há data certa de previsão" : (s.dataDraft ? s.dataDraft.split("-").reverse().join("/") : ""))
          : "sem data definida";
    const dataIsoDraft = s.quandoDraft === "hoje"
      ? cal.todayIso
      : s.quandoDraft === "amanha"
        ? cal.tomorrowIso
        : s.quandoDraft === "futuro"
          ? (s.semPrevisao ? null : (s.dataDraft || null))
          : s.quandoDraft === "tecnico"
            ? cal.todayIso
            : null;
    const notesTrim = String(s.standbyNotes || "").trim();
    const futuroOk = s.semPrevisao ? notesTrim.length >= 10 : !!s.dataDraft;
    const agendaPronta = !!s.tecnicoDraft && !!s.quandoDraft && (s.quandoDraft !== "futuro" || futuroOk);

    const hasScheduleBridge = typeof window !== "undefined" && typeof window.__openOsV2LoadScheduleData === "function";
    const areasSrc = hasScheduleBridge
      ? (Array.isArray(s.scheduleAreasData) ? s.scheduleAreasData : [])
      : REGIOES;
    const agendaQ = String(s.agendaTechQuery || "").trim().toLowerCase();
    const routeKm = this.clampRouteKm(s.routeHelpKm);
    const routeDay = s.quandoDraft === "amanha" ? "amanha" : "hoje";
    const routeHelpOn = !!s.routeHelpOpen && !!s.routeHelpOrigin && !s.routeHelpLoading;
    // Lista e mapa devem usar o mesmo conjunto: raio + dia selecionado (hoje/amanhã).
    const scopedPoints = routeHelpOn
      ? this.scopeRouteHelpPoints(s.routeHelpPoints, areasSrc, hasScheduleBridge, s.scheduleAreasData)
          .filter((p) => Number(p.km) <= routeKm)
          .filter((p) => !p.day || p.day === routeDay)
      : [];
    this._routeHelpCountMap = routeHelpOn ? this.buildNearbyCountMap(scopedPoints, routeKm) : null;
    const techColorMap = routeHelpOn ? buildTechColorMap(scopedPoints.map((p) => p.codTec)) : {};
    const regioes = areasSrc.map(r => {
      const areaKey = r.id != null ? String(r.id) : String(r.nome || r.name || "");
      const areaNome = r.nome || r.name || "—";
      const areaMatch = !agendaQ || areaNome.toLowerCase().indexOf(agendaQ) >= 0;
      let techList = (r.tecnicos || []).filter(t => {
        if (!agendaQ || areaMatch) return true;
        const techNome = (t.nome || t.name || String(t)).toLowerCase();
        return techNome.indexOf(agendaQ) >= 0;
      });
      if (routeHelpOn) {
        techList = techList.filter(t => this.nearbyCountForTech(t) > 0);
      }
      if (agendaQ && !areaMatch && techList.length === 0) return null;
      if (routeHelpOn && techList.length === 0) return null;
      const aberto = routeHelpOn || agendaQ ? true : s.regioesAbertas.indexOf(areaKey) >= 0;
      return {
        nome: areaNome,
        coordenador: r.coordenador || "",
        aberto: aberto,
        toggle: () => this.toggleIn("regioesAbertas", areaKey),
        caretStyle: "color:#a89cf0;display:flex;transition:transform .15s;transform:rotate(" + (aberto ? "90" : "0") + "deg)",
        tecnicos: techList.map(t => {
          const techNome = t.nome || t.name || String(t);
          const techId = t.id != null ? String(t.id) : techNome;
          const techSelected = s.tecnicoDraftObj
            ? String(s.tecnicoDraftObj.id) === techId
            : s.tecnicoDraft === techNome;
          const nearbyQtd = routeHelpOn ? this.nearbyCountForTech(t) : 0;
          const techCor = routeHelpOn ? colorForTech(padAgendaCodTec(t.id != null ? t.id : t.codigo), techColorMap) : "";
          return {
             nome: techNome,
             carga: t.carga || "",
             nearbyQtd: nearbyQtd,
             cor: techCor,
             selected: techSelected,
            pick: () => {
              if (techSelected) {
                // Desseleciona: volta a mostrar todos os pontos no mapa.
                this.setState({ tecnicoDraft: null, tecnicoDraftObj: null, routeHelpAgendaMirrorOpen: false });
                return;
              }
              this.setState({ tecnicoDraft: techNome, tecnicoDraftObj: t });
            },
            style: "display:flex;align-items:center;justify-content:space-between;gap:10px;padding:7px 11px 7px 30px;cursor:pointer;border-top:1px solid #f6f6fa;" +
              (techSelected ? "background:#f4f1ff" : "background:#fff"),
            className: "oosv2-agenda-tech-row" + (techSelected ? " is-selected" : "")
          };
        })
      };
    }).filter(Boolean);

    const he = this.props.historyOnly ? (this.props.historyEquip || null) : null;
    const equipBase = s.equip || (he && {
      modelo: he.modelo || "—",
      serie: he.serie || "—",
      patrimonio: he.patrimonio || "—",
      instalado: he.instalado || "—",
    }) || (selInfos[0] || { modelo: "—", serie: "—", patrimonio: "—", instalado: "—" });
    const hasHistBridge = typeof window !== "undefined" && typeof window.__openOsV2FetchHistory === "function";
    const liveHist = s.histLive;
    const ORDENS_SRC = liveHist ? (liveHist.ordens || []) : (hasHistBridge ? [] : HIST_ORDENS);
    const PECAS_SRC = liveHist ? (liveHist.pecas || []) : (hasHistBridge ? [] : HIST_PECAS);
    const PARETO_SRC = liveHist ? (liveHist.paretoRaw || []) : (hasHistBridge ? [] : HIST_PARETO);
    const PROD_MESES_SRC = liveHist && liveHist.producaoMeses && liveHist.producaoMeses.length
      ? liveHist.producaoMeses
      : (hasHistBridge ? [] : PRODUCAO_MESES);
    const PROD_SERIES_SRC = liveHist && liveHist.producaoSeries && liveHist.producaoSeries.length
      ? liveHist.producaoSeries
      : (hasHistBridge
        ? PRODUCAO_SERIES.map(se => ({ key: se.key, label: se.label, cor: se.cor, fill: se.fill, valores: [], medAtual: [] }))
        : PRODUCAO_SERIES);
    const colsAtivas = HIST_COLUNAS.filter(c => s.colunas.indexOf(c.key) >= 0);
    const colsPecas = PECA_COLUNAS.filter(c => s.colunasPecas.indexOf(c.key) >= 0);
    const larguraMinPecas = 100 + colsPecas.reduce((a, c) => a + c.min, 0) + colsPecas.length * 8;
    const gradePecasBase = "display:grid;grid-template-columns:100px " + colsPecas.map(c => c.largura).join(" ") + ";gap:8px;min-width:" + larguraMinPecas + "px;";
    const osCol = 124;
    const larguraMin = osCol + colsAtivas.reduce((a, c) => a + c.min, 0) + colsAtivas.length * 6;
    const gradeBase = "display:grid;grid-template-columns:" + osCol + "px " + colsAtivas.map(c => c.largura).join(" ") + ";gap:6px;min-width:" + larguraMin + "px;";

    return {
      contextoTopo: isMultipla ? "OS múltipla" : s.modo === "unica" ? "OS única" : "Novo atendimento",
      trilha: trilha,
      progressoTexto: "Etapa " + (idx + 1) + " de " + fluxo.length,
      etapaAtualLabel: concluido ? "Concluído" : rotulos[atual].label,
      etapaAtualHint: concluido ? "Ordens de serviço abertas" : rotulos[atual].hint,

      isEquip: !concluido && atual === "equip",
      isSelecao: !concluido && atual === "sel",
      isConf: !concluido && atual === "conf",
      isDefeito: !concluido && atual === "defeito",
      isFim: !concluido && atual === "fim",
      isDone: concluido,

      origens: origens, modos: modos,
      temOrigem: !!s.origem, temModo: !!s.origem && !!s.modo, isUnica: s.modo === "unica", isMultipla: isMultipla,
      isEstoqueMultipla: isEstoqueMultipla,

      buscaTitulo: isEstoqueMultipla
        ? "Informe a série ou patrimônio"
        : (isMultipla ? "Cliente ou contrato" : "Número de série ou patrimônio"),
      buscaDica: isEstoqueMultipla
        ? "Mínimo 4 caracteres · selecione um ou mais equipamentos"
        : (isMultipla ? "Mínimo 4 caracteres · depois selecione os equipamentos" : "Mínimo 4 caracteres"),
      buscaPlaceholder: isEstoqueMultipla || s.modo === "unica"
        ? "Pesquise série ou patrimônio…"
        : "Pesquise o cliente ou contrato…",
      query: s.query,
      setQuery: (e) => {
        const value = String(e.target.value || "").replace(/\s+/g, " ").trimStart().toUpperCase();
        const patch = {
          query: value,
          equip: null,
          apiHits: value.trim().length < 4 ? [] : s.apiHits
        };
        if (!isEstoqueMultipla) {
          patch.cliente = isMultipla ? null : s.cliente;
          patch.locaisLive = isMultipla ? [] : s.locaisLive;
        }
        this.setState(patch);
        this.scheduleSearch(value);
      },
      resultados: resultados,
      mostrarResultados: resultados.length > 0,
      buscandoApi: !!s.apiSearching,
      semResultados: s.query.trim().length >= 4 && !s.apiSearching && resultados.length === 0 && !s.cliente && !s.equip,

      estoqueSelecionados: isEstoqueMultipla
        ? selInfos.map((info) => ({
          serie: info.serie,
          titulo: info.serie + (info.patrimonio && info.patrimonio !== "—" ? " • " + info.patrimonio : ""),
          sub: info.modelo || "—",
          remove: (e) => { e.stopPropagation(); this.removeEstoqueSel(info.serie); }
        }))
        : [],
      podeAvancarEstoqueMulti: isEstoqueMultipla && s.sel.length > 0,
      semSelecaoEstoqueMulti: isEstoqueMultipla && s.sel.length === 0,
      clienteSelecionadoNome: s.cliente ? s.cliente.codigo + " " + s.cliente.nome : "",
      filtro: s.filtro, setFiltro: (e) => this.setState({ filtro: e.target.value }),
      arvore: arvore, arvoreVazia: arvore.length === 0,
      totalSelecionado: totalSelecionado, selecionados: selInfos,
      resumoLocais: locaisSelecionados.length ? locaisSelecionados.join(" · ") : "Nenhum local",
      listaModal: s.listaModal, abrirLista: () => this.setState({ listaModal: true }), fecharLista: () => this.setState({ listaModal: false }),
      podeAvancarMultipla: s.sel.length > 0, semSelecao: s.sel.length === 0,

      equip: {
        modelo: equipBase.modelo || "—",
        serie: equipBase.serie || "—",
        patrimonio: equipBase.patrimonio || "—",
        instalado: equipBase.instalado || "—",
        cliente: s.clienteLabel
          || (isMultipla && s.cliente ? ((s.cliente.codigo || "") + " " + (s.cliente.nome || s.cliente.classif || "")).trim() : "—")
      },
      contratoVencido: !!s.contratoVencidoFlag,
      mostrarEnderecoConf: mostrarEnderecoConf,
      mostrarUltimoConf: mostrarUltimoConf,
      enderecoAtual: enderecoAtual,
      localInternoAtual: s.localInterno || "—",
      temLocalInterno: !!(s.localInterno && String(s.localInterno).trim()),
      toggleEndereco: () => {
        const opening = !s.corrigindoEndereco;
        clearTimeout(this._addrT);
        this._addrSeq = (this._addrSeq || 0) + 1;
        this.setState({
          corrigindoEndereco: opening,
          enderecoQuery: "",
          enderecoHits: [],
          enderecoSearching: false,
          enderecoOriginal: s.enderecoOriginal || s.endereco
        }, () => {
          if (opening) setTimeout(() => this.focusAddrInput(), 40);
        });
      },
      btnEnderecoClass: "oosv2-addr-incorrect" + (s.corrigindoEndereco ? " is-on" : ""),
      corrigindoEndereco: s.corrigindoEndereco, enderecoQuery: s.enderecoQuery,
      setEnderecoQuery: (e) => {
        const value = e.target.value;
        this.setState({ enderecoQuery: value });
        this.scheduleAddressSearch(value);
      },
      buscandoEndereco: !!s.enderecoSearching,
      temSugestoesEndereco: (s.enderecoHits || []).length > 0,
      sugestoesEndereco: (s.enderecoHits || []).map(h => ({
        texto: h.texto || h.display,
        pick: () => this.applyAddressSuggestion(h)
      })),
      enderecoCorrigido: !!(s.enderecoOriginal && s.endereco && s.enderecoOriginal !== s.endereco),
      enderecoOriginal: s.enderecoOriginal || "",
      abrirLocalInterno: () => this.setState({ editandoLocalInterno: true, localInternoDraft: s.localInterno }),
      editandoLocalInterno: s.editandoLocalInterno, localInternoDraft: s.localInternoDraft,
      setLocalInterno: (e) => this.setState({ localInternoDraft: e.target.value }),
      salvarLocalInterno: () => {
        const value = String(s.localInternoDraft != null ? s.localInternoDraft : s.localInterno).trim();
        const applyLocal = (raw) => {
          if (!raw) return;
          raw.Endereco_Local = value;
          if (raw.endereco && typeof raw.endereco === "object") raw.endereco.local = value;
        };
        if (isMultipla && mesmoEnderecoMultipla) {
          selInfos.forEach((info) => applyLocal(info && info.raw));
        } else {
          applyLocal(s.equip && s.equip.raw);
        }
        this.setState({ localInterno: value, editandoLocalInterno: false });
      },
      cancelarLocalInterno: () => this.setState({ editandoLocalInterno: false, localInternoDraft: s.localInterno }),

      historicoAberto: this.props.historyOnly ? true : s.historicoAberto,
      historicoTotalOS: liveHist ? (liveHist.totalChamados || ORDENS_SRC.length) : ORDENS_SRC.length,
      colunasAberto: s.colunasAberto,
      toggleColunas: (e) => {
        if (e && e.stopPropagation) e.stopPropagation();
        this.setState({ colunasAberto: !s.colunasAberto, periodoAberto: false });
      },
      periodoAberto: !!s.periodoAberto,
      togglePeriodo: (e) => {
        if (e && e.stopPropagation) e.stopPropagation();
        this.setState({ periodoAberto: !s.periodoAberto, colunasAberto: false });
      },
      periodoOpcoes: [24, 12, 6, 3].map((m) => {
        const on = Number(s.histPeriodMonths) === m;
        return {
          months: m,
          label: `Últimos ${m} meses`,
          on,
          boxClass: "oosv2-cols-check" + (on ? " is-on" : ""),
          pick: (e) => {
            if (e && e.stopPropagation) e.stopPropagation();
            this.setHistPeriodMonths(m);
          },
        };
      }),
      mostrarSeletorColunas: s.histAba === "os" || s.histAba === "pecas",
      colunasControle: (s.histAba === "pecas" ? PECA_COLUNAS : HIST_COLUNAS).map(c => {
        const chave = s.histAba === "pecas" ? "colunasPecas" : "colunas";
        const lista = s[chave];
        const defs = s.histAba === "pecas" ? PECA_COLUNAS : HIST_COLUNAS;
        const on = lista.indexOf(c.key) >= 0;
        return {
          label: c.label, on: on,
          boxClass: "oosv2-cols-check" + (on ? " is-on" : ""),
          toggle: () => this.setState({ [chave]: on ? lista.filter(x => x !== c.key) : defs.filter(h => h.key === c.key || lista.indexOf(h.key) >= 0).map(h => h.key) })
        };
      }),
      colunasAtivas: colsAtivas.map(c => ({ label: c.label, headStyle: "font-size:9.5px;letter-spacing:.07em;text-transform:uppercase;color:#8a8a9e;font-weight:700;white-space:nowrap;overflow:hidden;text-overflow:ellipsis" })),
      colunasPecasAtivas: colsPecas.map(c => ({ label: c.label, headStyle: "font-size:9.5px;letter-spacing:.07em;text-transform:uppercase;color:#8a8a9e;font-weight:700;white-space:nowrap;overflow:hidden;text-overflow:ellipsis" + (c.key === "qtde" ? ";text-align:right" : "") })),
      gradeCabecalho: gradeBase + "padding:8px 12px;background:#f7f7fa;border-bottom:1px solid #ececf2",
      gradePecasCabecalho: gradePecasBase + "padding:8px 12px;background:#f7f7fa;border-bottom:1px solid #ececf2",
      abrirHistorico: () => {
        this.setState({ historicoAberto: true, histAba: "resumo", periodoAberto: false });
        if (!s.histLive && s.equip && s.equip.serie) this.loadHistoryFromApi(s.equip.serie, s.equip.instalado);
      },
      fecharHistorico: () => {
        if (typeof window !== "undefined" && typeof window.__openOsV2SetProductionChart === "function") {
          window.__openOsV2SetProductionChart({ clear: true });
        }
        if (this.props.historyOnly) {
          this.props.onClose?.();
          return;
        }
        this.setState({ historicoAberto: false, ganttTip: null, colunasAberto: false, periodoAberto: false });
      },
      historyOnly: !!this.props.historyOnly,
      fecharGanttTip: () => this.setState({ ganttTip: null }),
      keepGanttTip: (e) => { if (e && e.stopPropagation) e.stopPropagation(); },
      ganttTipAberto: !!s.ganttTip,
      ganttTip: s.ganttTip || {
        style: "display:none", os: "", temReincidencia: false, reincidencia: "",
        defeito: "", tecnico: "", condicao: "", temPecas: false, pecas: []
      },
      abaResumo: s.histAba === "resumo", abaOS: s.histAba === "os", abaPecas: s.histAba === "pecas",
      historicoAbas: [
        { key: "resumo", label: "Resumo", badge: "" },
        { key: "os", label: "Ordens de serviço", badge: String(ORDENS_SRC.length) },
        { key: "pecas", label: "Trocas de peças", badge: String(PECAS_SRC.length) }
      ].map(a => {
        const ativa = s.histAba === a.key;
        const podeColunas = a.key === "os" || a.key === "pecas";
        const podePeriodo = a.key === "resumo" || a.key === "os";
        return {
          label: a.label,
          badge: a.badge,
          temBadge: !!a.badge,
          mostrarPeriodo: ativa && podePeriodo,
          mostrarColunas: ativa && podeColunas,
          pick: () => this.setState({ histAba: a.key, ganttTip: null, colunasAberto: false, periodoAberto: false }),
          className: "oosv2-hist-tab-item" + (ativa ? " is-active" : "")
        };
      }),
      hist: (() => {
        const totalPareto = PARETO_SRC.reduce((a, b) => a + b.qtd, 0);
        let acum = 0;
        const maior = PARETO_SRC.length ? PARETO_SRC[0].qtd : 1;
        const pareto = [];
        if (PARETO_SRC.length && totalPareto) {
          for (let i = 0; i < PARETO_SRC.length && pareto.length < 5; i++) {
            const p = PARETO_SRC[i];
            acum += p.qtd;
            const pctAcum = Math.round(acum / totalPareto * 100);
            const dentro = pctAcum - Math.round(p.qtd / totalPareto * 100) < 80;
            pareto.push({
              defeito: p.defeito, qtd: p.qtd, acumulado: pctAcum + "%", highlight: dentro,
              labelStyle: "font-size:11.5px;font-weight:" + (dentro ? "700" : "500") + ";white-space:nowrap;overflow:hidden;text-overflow:ellipsis;color:" + (dentro ? "#16161d" : "#7c7c90"),
              barStyle: "height:100%;border-radius:6px;transition:width .3s;width:" + (p.qtd / maior * 100) + "%;background:" + (dentro ? "linear-gradient(90deg,#6d3ef5,#8a63f8)" : "#d6d6e0"),
              acumStyle: "font-size:11px;font-weight:700;text-align:right;font-family:'JetBrains Mono',monospace;color:" + (dentro ? "#6d3ef5" : "#a0a0b2")
            });
            if (pctAcum >= 80) break;
          }
        }
        const corretivas = liveHist ? liveHist.corretivas : ORDENS_SRC.filter(o => o.tipo === "Corretiva").length;
        const preventivas = liveHist ? liveHist.preventivas : ORDENS_SRC.filter(o => o.tipo === "Preventiva").length;
        const totalChamados = liveHist ? liveHist.totalChamados : (corretivas + preventivas);
        const baseBarra = totalChamados || 1;
        return {
          tempoInstalado: liveHist ? liveHist.tempoInstalado : "3 anos e 6 meses",
          dataInstalacao: liveHist ? liveHist.dataInstalacao : "30/01/2023",
          periodo: liveHist ? liveHist.periodo : (`últimos ${[3, 6, 12, 24].includes(Number(s.histPeriodMonths)) ? s.histPeriodMonths : 24} meses`),
          totalChamados: totalChamados,
          corretivas: corretivas, preventivas: preventivas,
          barraCorretivas: "background:#6d3ef5;width:" + (totalChamados ? (corretivas / baseBarra * 100) : 0) + "%",
          barraPreventivas: "background:#12a45a;width:" + (totalChamados ? (preventivas / baseBarra * 100) : 0) + "%",
          ultimaCorretiva: liveHist ? liveHist.ultimaCorretiva : "há 3 meses",
          ultimaCorretivaData: liveHist ? liveHist.ultimaCorretivaData : "09/05/2025",
          ultimaCorretivaOS: liveHist ? liveHist.ultimaCorretivaOS : "299959",
          ultimaPreventiva: liveHist ? liveHist.ultimaPreventiva : "há 6 meses",
          ultimaPreventivaData: liveHist ? liveHist.ultimaPreventivaData : "12/02/2025",
          ultimaPreventivaOS: liveHist ? liveHist.ultimaPreventivaOS : "297431",
          pareto: pareto,
          linhaTempo: (() => {
            const dt = (br) => { const p = String(br || "").split("/"); return new Date(+p[2], +p[1] - 1, +p[0]).getTime(); };
            const openGanttTip = (o, e) => {
              if (e && e.stopPropagation) e.stopPropagation();
              const key = String(o.numero || "");
              if (s.ganttTip && s.ganttTip.key === key) {
                this.setState({ ganttTip: null });
                return;
              }
              const pecas = (o.pecas || []).map(p => ({
                nome: p.produto || p.nome || "—",
                qtde: String(p.qtde != null ? p.qtde : "—")
              }));
              const reinc = String(o.reincidencia || o.reincidenteDe || "").trim();
              const el = e && e.currentTarget ? e.currentTarget : null;
              const rect = el ? el.getBoundingClientRect() : { left: 120, top: 200, width: 60, bottom: 220, right: 180 };
              const body = typeof document !== "undefined" ? document.querySelector(".oosv2-hist-body") : null;
              const bound = body ? body.getBoundingClientRect() : {
                left: 8, top: 8, right: (typeof window !== "undefined" ? window.innerWidth : 800) - 8,
                bottom: (typeof window !== "undefined" ? window.innerHeight : 600) - 8
              };
              const tipW = 230;
              let left = rect.left + rect.width / 2;
              let tx = "-50%";
              if (left + tipW / 2 > bound.right - 10) { left = bound.right - 10; tx = "-100%"; }
              else if (left - tipW / 2 < bound.left + 10) { left = bound.left + 10; tx = "0"; }
              let top = rect.bottom + 8;
              let ty = "0";
              if (top + 170 > bound.bottom - 10) {
                top = rect.top - 8;
                ty = "-100%";
              }
              this.setState({
                ganttTip: {
                  key: key,
                  os: key || "—",
                  temReincidencia: !!reinc,
                  reincidencia: reinc,
                  defeito: o.defeito || "Sem defeito",
                  tecnico: o.tecnico || "—",
                  condicao: o.condicao || "—",
                  temPecas: pecas.length > 0,
                  pecas: pecas,
                  style: "position:fixed;left:" + left + "px;top:" + top + "px;transform:translate(" + tx + "," + ty + ");z-index:21000;"
                }
              });
            };
            const eventos = ORDENS_SRC.filter(o => o.tipo === "Corretiva" || o.tipo === "Preventiva").map(o => {
              const pecas = o.pecas || [];
              return {
                t: o.aberturaDate ? o.aberturaDate.getTime() : dt(o.abertura),
                data: String(o.abertura || "").slice(0, 5),
                rotulo: o.defeito,
                tipo: o.tipo,
                temPeca: pecas.length > 0 || !!o.temPecaFlag,
                open: (e) => openGanttTip(o, e)
              };
            }).filter(e => !Number.isNaN(e.t));
            if (!eventos.length) {
              return { marcas: [], chamados: [], estiloFaixaChamados: "position:relative;overflow:hidden;height:34px;border:1px solid #f0f0f5;border-radius:10px;background:#fbfbfd" };
            }
            const todos = eventos.map(e => e.t);
            const min = Math.min.apply(null, todos) - 45 * 86400000;
            const max = Math.max.apply(null, todos) + 45 * 86400000;
            const span = Math.max(1, max - min);
            const pos = (t) => (t - min) / span * 100;
            const marcas = [];
            const dIni = new Date(min);
            let cur = new Date(dIni.getFullYear(), dIni.getMonth() + (3 - dIni.getMonth() % 3), 1);
            while (cur.getTime() < max) {
              const p = pos(cur.getTime());
              marcas.push({
                label: ["jan", "fev", "mar", "abr", "mai", "jun", "jul", "ago", "set", "out", "nov", "dez"][cur.getMonth()] + "/" + String(cur.getFullYear()).slice(2),
                linhaStyle: "position:absolute;top:0;bottom:0;width:1px;background:#f0f0f5;left:" + p + "%",
                rotuloStyle: "position:absolute;top:0;transform:translateX(-50%);font-size:9.5px;font-weight:700;color:#a0a0b2;white-space:nowrap;left:" + p + "%"
              });
              cur = new Date(cur.getFullYear(), cur.getMonth() + 3, 1);
            }
            const montar = (lista, cores, LARGURA_PCT) => {
              const ordenada = lista.slice().sort((a, b) => a.t - b.t);
              const ultimo = [-999, -999, -999];
              let maxFaixa = 0;
              const itens = ordenada.map(e => {
                const p = pos(e.t);
                let faixa = 0;
                while (faixa < 2 && p - ultimo[faixa] < LARGURA_PCT) faixa++;
                ultimo[faixa] = p;
                if (faixa > maxFaixa) maxFaixa = faixa;
                const cor = cores[e.tipo] || cores.Corretiva;
                const margem = LARGURA_PCT / 2 + 2;
                const ancora = p <= margem ? "left:6px;" : (p >= 100 - margem ? "right:6px;" : "left:" + p + "%;transform:translateX(-50%);");
                return {
                  data: e.data, rotulo: e.rotulo, temPeca: !!e.temPeca, open: e.open,
                  pillClassName: "oosv2-hist-gantt-pill " + (e.tipo === "Preventiva" ? "oosv2-hist-gantt-pill--prev" : e.tipo === "Peça" ? "oosv2-hist-gantt-pill--peca" : "oosv2-hist-gantt-pill--cor"),
                  chaveStyle: "display:flex;align-items:center;color:#b5760f;flex:0 0 auto",
                  dotStyle: "width:7px;height:7px;border-radius:999px;flex:0 0 auto;background:" + cor.dot,
                  pillStyle: "position:absolute;display:flex;align-items:center;gap:5px;padding:3px 8px;border-radius:999px;cursor:pointer;white-space:nowrap;" + ancora + "top:" + (6 + faixa * 22) + "px;border:1px solid " + cor.borda + ";background:" + cor.fundo + ";color:" + cor.texto
                };
              });
              return { itens: itens, altura: 12 + (maxFaixa + 1) * 22 };
            };
            const cores = {
              Corretiva: { dot: "#6d3ef5", borda: "#e2daff", fundo: "#f7f4ff", texto: "#3d2a7a" },
              Preventiva: { dot: "#12a45a", borda: "#c7ecd8", fundo: "#f2fbf6", texto: "#0f6b3f" },
              "Peça": { dot: "#d99320", borda: "#f2ddb4", fundo: "#fdf8ee", texto: "#8a5b0c" }
            };
            const laneCh = montar(eventos, cores, 13);
            const laneStyle = (h) => "position:relative;overflow:hidden;height:" + h + "px;border:1px solid #f0f0f5;border-radius:10px;background:#fbfbfd";
            return { marcas: marcas, chamados: laneCh.itens, estiloFaixaChamados: laneStyle(laneCh.altura) };
          })(),
          ordens: ORDENS_SRC.map((o, i) => {
            const anterior = ORDENS_SRC[i + 1];
            const celulas = colsAtivas.map(col => {
              const base = "display:flex;align-items:baseline;gap:5px;min-width:0;";
              if (col.key === "tipo") return {
                temAlerta: false, alerta: "", alertaStyle: "",
                valor: o.tipo, delta: "", deltaStyle: "display:none",
                cellStyle: base + "align-items:center",
                cellClassName: "oosv2-hist-tipo-badge " + (o.tipo === "Corretiva" ? "oosv2-hist-tipo-badge--cor" : "oosv2-hist-tipo-badge--prev"),
                valorStyle: "font-size:10.5px;font-weight:700;border-radius:999px;padding:2px 8px;white-space:nowrap;" + (o.tipo === "Corretiva" ? "background:#f2eeff;color:#5a2ee0" : "background:#e7f7ee;color:#12a45a")
              };
              if (CONTADOR_IDX[col.key] !== undefined) {
                const idxC = CONTADOR_IDX[col.key];
                const val = o.contadores[idxC];
                const dif = anterior ? val - anterior.contadores[idxC] : null;
                return {
                  temAlerta: false, alerta: "", alertaStyle: "",
                  valor: nf(val),
                  valorStyle: "font-size:11.5px;font-weight:600;font-family:'JetBrains Mono',monospace",
                  delta: dif === null ? "" : (dif >= 0 ? "↗ +" : "↘ ") + nf(dif),
                  deltaStyle: dif === null ? "display:none" : "font-size:10px;font-weight:700;font-family:'JetBrains Mono',monospace;white-space:nowrap;color:" + (dif >= 0 ? "#12a45a" : "#d1544a"),
                  cellStyle: "display:flex;flex-direction:column;gap:1px;min-width:0;line-height:1.25"
                };
              }
              if (col.key === "defeito") {
                const alerta = String(o.defeitoAlert || o.alerta || "").trim();
                return {
                  valor: o.defeito,
                  temAlerta: !!alerta,
                  alerta: alerta,
                  alertaStyle: alerta ? this.alertaChipStyle(o.colorBg || o.alertaCor) : "",
                  delta: "", deltaStyle: "display:none",
                  cellStyle: "display:flex;align-items:center;gap:6px;min-width:0;",
                  cellClassName: "oosv2-hist-cell-val oosv2-hist-cell-val--strong",
                  valorStyle: "font-size:11.5px;font-weight:600;color:#16161d;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;min-width:0;"
                };
              }
              const textos = { abertura: o.abertura, tecnico: o.tecnico, condicao: o.condicao, fechamento: o.fechamento, cliente: o.cliente };
              const mono = col.key === "abertura" || col.key === "fechamento" || col.key === "cliente";
              return {
                temAlerta: false, alerta: "", alertaStyle: "",
                valor: textos[col.key], delta: "", deltaStyle: "display:none", cellStyle: base,
                valorStyle: "font-size:11.5px;" +
                  (col.key === "condicao"
                    ? "white-space:normal;overflow:visible;font-weight:600;color:#4a4a5c;line-height:1.25"
                    : "white-space:nowrap;overflow:hidden;text-overflow:ellipsis;color:#4a4a5c;" +
                      (mono ? "font-family:'JetBrains Mono',monospace" : ""))
              };
            });
            return {
              numero: o.numero, motivo: o.motivo, laudo: o.laudo, pecas: o.pecas || [], celulas: celulas,
              temPeca: !!(o.pecas && o.pecas.length) || !!o.temPecaFlag,
              reincidente: !!(o.reincidencia || o.reincidenteDe),
              reincidenteOs: String(o.reincidencia || o.reincidenteDe || "").trim(),
              returnCount: Number(o.returnCount) || 0,
              tipo: o.tipo,
              defeito: o.defeito,
              cliente: o.cliente,
              ciclos: (o.ciclos || []).map(c => ({ ...c, contadorPB: nf(c.contadorPB) })),
              aberto: s.histOS === o.numero,
              toggle: () => this.setState({ histOS: s.histOS === o.numero ? null : o.numero }),
              caretStyle: "color:#b4b4c2;display:flex;flex:0 0 auto;transition:transform .15s;transform:rotate(" + (s.histOS === o.numero ? "90" : "0") + "deg)",
              rowStyle: gradeBase + "align-items:center;padding:9px 12px;cursor:pointer;" + (s.histOS === o.numero ? "background:#faf9ff" : "background:#fff")
            };
          }),
          pecas: PECAS_SRC.map((p, i) => {
            const anterior = PECAS_SRC[i + 1];
            const base = "display:flex;align-items:baseline;gap:5px;min-width:0;";
            const celulas = colsPecas.map(col => {
              if (PECA_CONTADOR_IDX[col.key] !== undefined) {
                const ic = PECA_CONTADOR_IDX[col.key];
                const val = p.contadores[ic];
                const dif = anterior ? val - anterior.contadores[ic] : null;
                return {
                  valor: nf(val), sub: "", subStyle: "display:none",
                  valorStyle: "font-size:11.5px;font-weight:600;font-family:'JetBrains Mono',monospace",
                  delta: dif === null ? "" : (dif >= 0 ? "↗ +" : "↘ ") + nf(dif),
                  deltaStyle: dif === null ? "display:none" : "font-size:10px;font-weight:700;font-family:'JetBrains Mono',monospace;white-space:nowrap;color:" + (dif >= 0 ? "#12a45a" : "#d1544a"),
                  cellStyle: "display:flex;flex-direction:column;gap:1px;min-width:0;line-height:1.25"
                };
              }
              if (col.key === "peca") return {
                valor: p.nome, sub: "ref. " + p.referencia, delta: "", deltaStyle: "display:none",
                cellStyle: "display:flex;flex-direction:column;min-width:0;gap:1px",
                valorStyle: "font-size:11.5px;font-weight:600;white-space:nowrap;overflow:hidden;text-overflow:ellipsis",
                subStyle: "font-size:10.5px;color:#a0a0b2;white-space:nowrap;overflow:hidden;text-overflow:ellipsis"
              };
              const textos = { data: p.data, codigo: p.codigo, qtde: String(p.qtde), os: p.os, vida: p.vidaUtil };
              const mono = col.key !== "vida";
              return {
                valor: textos[col.key], sub: "", subStyle: "display:none", delta: "", deltaStyle: "display:none",
                cellStyle: base + (col.key === "qtde" ? "justify-content:flex-end" : ""),
                valorStyle: "font-size:11.5px;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;" +
                  (col.key === "os" ? "color:#5a2ee0;font-weight:600;" : "color:#4a4a5c;") +
                  (col.key === "qtde" ? "font-weight:700;color:#16161d;" : "") + (mono ? "font-family:'JetBrains Mono',monospace" : "font-weight:600")
              };
            });
            return {
              pedido: p.pedido, celulas: celulas,
              rowStyle: gradePecasBase + "align-items:center;padding:9px 12px;background:#fff;border-bottom:1px solid #f4f4f8"
            };
          }),
          producao: (() => {
            const meses = PROD_MESES_SRC;
            const seriesAll = PROD_SERIES_SRC;
            const cicloMensal = liveHist && liveHist.cicloMensal != null ? Number(liveHist.cicloMensal) : null;
            const cicloOk = Number.isFinite(cicloMensal) && cicloMensal > 0 ? cicloMensal : null;
            const ativas = seriesAll.filter(se => s.seriesProducao.indexOf(se.key) >= 0);
            const temProducao = (meses || []).length > 0 && seriesAll.some(se =>
              (Array.isArray(se.valores) ? se.valores : []).some(v => Number(v) > 0)
            );
            if (
              s.historicoAberto &&
              s.histAba === "resumo" &&
              typeof window !== "undefined" &&
              typeof window.__openOsV2SetProductionChart === "function"
            ) {
              if (!temProducao) {
                window.__openOsV2SetProductionChart({ clear: true });
              } else {
                window.__openOsV2SetProductionChart({
                  meses: meses,
                  series: seriesAll.map(se => ({
                    key: se.key,
                    label: se.label,
                    cor: se.cor,
                    valores: Array.isArray(se.valores) ? se.valores.slice() : [],
                    medAtual: Array.isArray(se.medAtual) ? se.medAtual.slice() : []
                  })),
                  activeKeys: s.seriesProducao.slice(),
                  cicloMensal: cicloOk
                });
              }
            }
            const legenda = seriesAll.map(se => {
              const on = s.seriesProducao.indexOf(se.key) >= 0;
              return {
                label: se.label, on: on, static: false,
                toggle: () => this.setState({ seriesProducao: on ? s.seriesProducao.filter(k => k !== se.key) : s.seriesProducao.concat([se.key]) }),
                style: "display:flex;align-items:center;gap:6px;padding:3px 9px;border-radius:999px;cursor:pointer;font-size:10.5px;font-weight:700;transition:background .15s;" +
                  (on ? "border:1px solid #e2e2ea;background:#fff;color:#3c3c4c" : "border:1px solid #f0f0f5;background:#fbfbfd;color:#a8a8b8"),
                dotStyle: "width:8px;height:8px;border-radius:999px;flex:0 0 auto;background:" + (on ? se.cor : "#d6d6e0"),
                dotClass: ""
              };
            });
            if (cicloOk != null) {
              legenda.push({
                label: "Ciclo mensal",
                on: true,
                static: true,
                toggle: null,
                style: "display:flex;align-items:center;gap:6px;padding:3px 9px;border-radius:999px;font-size:10.5px;font-weight:700;border:1px solid #e2e2ea;background:#fff;color:#3c3c4c;cursor:default",
                dotStyle: "",
                dotClass: "oosv2-hist-prod-legend-dot--ciclo"
              });
            }

            const medias = ativas.map(se => {
              const vals = (Array.isArray(se.valores) ? se.valores : [])
                .map(v => Number(v))
                .filter(n => Number.isFinite(n));
              const media = vals.length ? vals.reduce((a, b) => a + b, 0) / vals.length : 0;
              const meds = Array.isArray(se.medAtual) ? se.medAtual : [];
              let ultimo = null;
              for (let i = meds.length - 1; i >= 0; i -= 1) {
                if (meds[i] == null || meds[i] === '') continue;
                const n = Number(meds[i]);
                if (Number.isFinite(n)) {
                  ultimo = Math.round(n);
                  break;
                }
              }
              return {
                key: se.key,
                label: se.label,
                cor: se.cor,
                media: Math.round(media),
                mediaLabel: nf(Math.round(media)),
                ultimo,
                ultimoLabel: ultimo != null ? nf(ultimo) : null
              };
            });

            const monthCount = (meses || []).length;
            const monthTotals = [];
            for (let i = 0; i < monthCount; i += 1) {
              monthTotals.push(
                ativas.reduce((acc, se) => acc + (Number(se.valores?.[i]) || 0), 0)
              );
            }
            const totalCopias = monthTotals.reduce((a, b) => a + b, 0);
            const mediaMensal = monthTotals.length ? totalCopias / monthTotals.length : 0;
            let pctDiff = null;
            if (cicloOk != null && cicloOk > 0 && mediaMensal > 0) {
              pctDiff = ((mediaMensal - cicloOk) / cicloOk) * 100;
            }
            const acimaCiclo = pctDiff != null ? pctDiff >= 0 : null;
            const comparativo = temProducao && ativas.length > 0 && monthTotals.length > 0 ? {
              totalCopias,
              totalLabel: nf(Math.round(totalCopias)),
              mediaMensal: Math.round(mediaMensal),
              mediaMensalLabel: nf(Math.round(mediaMensal)),
              cicloMensal: cicloOk,
              cicloMensalLabel: cicloOk != null ? nf(cicloOk) : null,
              pctDiff,
              pctLabel: pctDiff == null ? null : fmtPct(pctDiff),
              acimaMedia: acimaCiclo,
              texto: pctDiff == null
                ? null
                : (acimaCiclo
                  ? "acima do ciclo"
                  : "abaixo do ciclo")
            } : null;

            return {
              semProducao: !temProducao,
              semSerie: ativas.length === 0,
              cicloMensal: cicloOk,
              legenda,
              medias,
              comparativo
            };
          })(),
          rodape: "Clique em um chamado na linha do tempo para ver o detalhe; nas ordens de serviço, clique na linha para abrir motivo, laudo e peças. Dados dos " + (liveHist && liveHist.periodo ? liveHist.periodo : (`últimos ${[3, 6, 12, 24].includes(Number(s.histPeriodMonths)) ? s.histPeriodMonths : 24} meses`)) + "."
        };
      })(),
      ultimo: s.ultimoLive || {
        os: "—", data: "—", tipo: "—", tecnico: "—", solicitante: "—",
        motivo: s.temUltimo === false && s.equip ? "Sem histórico recente" : "—",
        defeito: "—", observacao: "—", solucao: "—",
        laudoData: "—", laudoTexto: "—", condicao: "—", contadores: [],
        defeitoAlert: "", colorBg: ""
      },
      temUltimoAlerta: !!(s.ultimoLive && String(s.ultimoLive.defeitoAlert || "").trim()),
      ultimoAlerta: s.ultimoLive ? String(s.ultimoLive.defeitoAlert || "").trim() : "",
      ultimoAlertaStyle: (s.ultimoLive && s.ultimoLive.defeitoAlert) ? this.alertaChipStyle(s.ultimoLive.colorBg) : "",
      temUltimo: !!s.temUltimo,
      ultimoAberto: s.ultimoAberto,
      toggleUltimo: () => this.setState({ ultimoAberto: !s.ultimoAberto, defeitoDetalheAberto: false }),
      caretUltimoStyle: "color:#8a8a9e;display:flex;transition:transform .15s;transform:rotate(" + (s.ultimoAberto ? "90" : "0") + "deg)",
      defeitoDetalheAberto: s.defeitoDetalheAberto,
      obsTipBtnClass: "oosv2-ultimo-obs-btn" + (s.defeitoDetalheAberto ? " is-on" : ""),
      toggleDefeitoDetalhe: (e) => {
        if (e && e.stopPropagation) e.stopPropagation();
        this.setState({ defeitoDetalheAberto: !s.defeitoDetalheAberto });
      },
      laudoAberto: s.laudoAberto, laudoLabel: s.laudoAberto ? "Fechar laudo" : "Ver laudo",
      toggleLaudo: () => this.setState({ laudoAberto: !s.laudoAberto }),

      solicitante: s.solicitante, setSolicitante: (e) => this.setState({ solicitante: e.target.value }),
      contato: s[this.phoneKey(s.tipoContato)] || "",
      setContato: (e) => {
        const key = this.phoneKey(this.state.tipoContato);
        this.setState({ [key]: this.maskPhone(e.target.value) });
      },
      emailDraft: s.emailDraft || "",
      temEmailChips: (s.emails || []).length > 0,
      emailChips: (s.emails || []).map(addr => ({
        addr: addr,
        remove: () => {
          const emails = (this.state.emails || []).filter(x => x !== addr);
          this.setState({ emails: emails, email: emails.join(";") });
        }
      })),
      setEmail: (e) => this.applyEmailInput(e.target.value),
      onEmailKey: (e) => {
        if (e.key === "Enter") {
          if (e.preventDefault) e.preventDefault();
          this.commitEmailDraft();
        }
        if (e.key === "Backspace" && !String(this.state.emailDraft || "") && (this.state.emails || []).length) {
          const emails = this.state.emails.slice(0, -1);
          this.setState({ emails: emails, email: emails.join(";") });
        }
      },
      onEmailBlur: () => this.commitEmailDraft(),
      emailHint: !emailDraftOk ? "e-mail inválido" : exigirEmail ? "obrigatório" : "opcional",
      emailHintStyle: "font-size:10px;font-weight:600;color:" + (!emailDraftOk ? "#e0453a" : "#a0a0b2"),
      marcaSolicitante: "width:6px;height:6px;border-radius:999px;" + (solicitanteOk ? "background:#12a45a" : "background:#e0453a"),
      marcaContato: "width:6px;height:6px;border-radius:999px;" + (contatoOk ? "background:#12a45a" : "background:#e0453a"),
      inputSolicitante: INPUT_BASE.replace("padding:0 10px", "padding:0 28px 0 10px") + "var(--border-subtle, #e6e6ef)",
      inputContato: INPUT_BASE.replace("width:100%", "flex:1;min-width:0").replace("padding:0 10px", "padding:0 28px 0 10px") + "var(--border-subtle, #e6e6ef)",
      solicitanteInputClass: "oosv2-solicitante-input oosv2-conf-input" + (solicitanteOk ? "" : " is-invalid"),
      contatoInputClass: "oosv2-conf-input" + (contatoOk ? "" : " is-invalid"),
      tbSolicitante: this.tb02112Btn("solicitante", "Preencher solicitante do equipamento"),
      tbContato: this.tb02112Btn("contato", "Preencher contato do equipamento"),
      tbEmail: this.tb02112Btn("email", "Preencher email do equipamento"),
      emailBoxClass: "oosv2-email-field" + (emailOk ? "" : " is-invalid"),
      tiposContato: TIPOS_CONTATO.map((t, i) => {
        const filled = this.phoneDigits(s[this.phoneKey(t)]) >= 10;
        const on = s.tipoContato === t;
        return {
          label: t,
          pick: () => this.setState({ tipoContato: t }),
          className: "oosv2-fone-type" + (on ? " is-on" : "") + (filled ? " is-filled" : ""),
          style: "padding:0 9px;height:34px;display:flex;align-items:center;font-size:11px;font-weight:700;cursor:pointer;" +
            (i < TIPOS_CONTATO.length - 1 ? "border-right:1px solid var(--border-subtle, #f0f0f5);" : "") +
            (on ? "background:#6d3ef5;color:#fff" : "background:var(--input-bg, #fff);color:#8a8a9e")
        };
      }),
      form1Ok: form1Ok, form1Pendente: !form1Ok, form1Faltando: "Falta: " + faltas1.join(", "),

      defeitoQuery: s.defeitoQuery,
      setDefeitoQuery: (e) => {
        const v = e.target.value;
        this.setState({ defeitoQuery: v, defeito: "", defeitoCodigo: "", defeitoObj: null, tipoOsValue: null });
        this.scheduleDefeitoSearch(v);
      },
      defeitosFiltrados: defeitosFiltrados, mostrarDefeitos: mostrarDefeitos,
      temDefeito: !!s.defeito, defeito: s.defeito || "—",
      limparDefeito: () => this.setState({ defeito: "", defeitoQuery: "", defeitoCodigo: "", defeitoObj: null, obs: "", defeitoHits: [], defeitoSearching: false, tipoOsValue: null }, () => {
        this.syncTipoOsComDefeito();
        this.focusSoon(".oosv2-defeito-input");
      }),
      obs: s.obs, setObs: (e) => this.setState({ obs: e.target.value }),
      obsContador: s.obs.trim().length + "/15",
      contadorObsClass: "oosv2-obs-counter" + (s.obs.trim().length >= 15 ? " is-ok" : " is-short"),
      defeitoOk: defeitoOk, defeitoPendente: !defeitoOk,
      defeitoFaltando: !s.defeito
        ? "Selecione o defeito"
        : (mostrarTiposOs && (!tipoOsValue || allowedTipos.indexOf(tipoOsValue) < 0))
          ? "Selecione o tipo de OS permitido"
          : "Observação com no mínimo 15 caracteres",

      mostrarTiposOs: mostrarTiposOs,
      defeitoVinculoAtivo: !!s.defeitoEquipVinculoAtivo,
      tiposOS: this.tipoOptionsForPicker().filter(o => allowedTipos.indexOf(o.value) >= 0).map(o => ({
        label: o.label,
        pick: () => this.setState({ tipoOsValue: o.value }),
        className: "oosv2-tipo-os-chip" + (tipoOsValue === o.value ? " is-on" : ""),
        style: tipoOsValue === o.value ? CHIP_ON : CHIP_OFF
      })),
      tipoOS: tipoOS,
      tipoOsValue: tipoOsValue,
      contadoresAberto: s.contadoresAberto,
      contadoresLabel: s.contadoresAberto ? "Ocultar contadores" : "+ Informar contadores (opcional)",
      contadoresLoading: !!s.contadoresLoading,
      mostrarContadoresInputs: s.contadoresAberto && !s.contadoresLoading,
      toggleContadores: () => this.toggleContadores(),
      contPb: s.contPb,
      contCor: s.contCor,
      contTotal: s.contTotal,
      contPbPh: s.lastContPb > 0 ? this.formatCounterMask(s.lastContPb) : "0",
      contCorPh: s.lastContCor > 0 ? this.formatCounterMask(s.lastContCor) : "0",
      contTotalPh: s.lastContTotal > 0 ? this.formatCounterMask(s.lastContTotal) : "0",
      setContPb: (e) => this.setContadorMasked("pb", e.target.value),
      setContCor: (e) => this.setContadorMasked("cor", e.target.value),
      setContTotal: (e) => this.setContadorMasked("total", e.target.value),

      cardProgramarClass: "oosv2-programar-card" + (s.agenda ? " is-scheduled" : ""),
      cardProgramarStyle: "margin-top:16px;border-radius:14px;padding:13px 14px;" + (s.agenda ? "border:1.5px solid #bfe8cf;background:#f5fcf8" : "border:1.5px solid #d6d6de;background:linear-gradient(180deg,#f7f7f9,#fff)"),
      iconeProgramarClass: "oosv2-programar-icon" + (s.agenda ? " is-scheduled" : ""),
      iconeProgramarStyle: "width:34px;height:34px;border-radius:11px;display:flex;align-items:center;justify-content:center;flex:0 0 auto;" + (s.agenda ? "background:#e7f7ee;color:#12a45a" : "background:#33333f;color:#fff"),
      textoProgramarClass: "oosv2-programar-text" + (s.agenda ? " is-scheduled" : ""),
      agendaResumo: s.agenda ? s.agenda.tecnico + " · " + s.agenda.data : "Defina técnico e data agora e adiante o atendimento",
      agendaBotao: s.agenda ? "Alterar" : "Programar atendimento",
      textoProgramarStyle: "font-size:11.5px;font-weight:600;margin-top:1px;" + (s.agenda ? "color:#12a45a" : "color:#8a8a9e"),
      botaoAgendaClass: "oosv2-programar-btn" + (s.agenda ? " is-scheduled" : ""),
      abrirAgenda: () => {
        const patch = {
          agendaModal: true,
          quandoDraft: s.agenda ? s.agenda.quando : null,
          tecnicoDraft: s.agenda ? s.agenda.tecnico : null,
          tecnicoDraftObj: s.agenda ? s.agenda.tecnicoObj : null,
          dataDraft: s.agenda && s.agenda.dataIso ? s.agenda.dataIso : "",
          semPrevisao: s.agenda ? !!s.agenda.noCertainDate : false,
          standbyNotes: s.agenda && s.agenda.standbyNotes ? s.agenda.standbyNotes : ""
        };
        this.setState(patch, () => this.loadScheduleAreas());
      },
      fecharAgenda: () => {
        const closePicker = typeof window !== "undefined" ? window.__openOsV2CloseFutureDatePicker : null;
        if (typeof closePicker === "function") closePicker();
        const cancelVoice = typeof window !== "undefined" ? window.__openOsV2CancelAgendaVoice : null;
        if (typeof cancelVoice === "function") cancelVoice();
        this.stopMonitoredPoll();
        if (this.props.agendaOnly) {
          this.props.onClose?.();
          return;
        }
        this.setState({ agendaModal: false, routeHelpOpen: false, routeHelpAgendaMirrorOpen: false, routeHelpOrigin: null, routeHelpPoints: [], routeHelpError: "", routeHelpLoading: false, routeHelpMonitoredTechs: [] });
      },
      agendaOnly: !!this.props.agendaOnly,
      hideApenasTecnico: !!this.props.hideApenasTecnico,
      agendaDialogTitle: this.props.agendaDialogTitle || "Programar atendimento",
      agendaConfirming: !!this.props.agendaConfirming,
      agendaModal: s.agendaModal, pedirData: s.quandoDraft === "futuro",
      dataDraft: s.dataDraft,
      dataDraftMin: cal.minFutureIso,
      dataDraftLabel: s.dataDraft ? s.dataDraft.split("-").reverse().join("/") : "Selecionar data",
      dataPickerDisabled: !!s.semPrevisao,
      dataPickerBtnClass: "oosv2-agenda-date-btn" + (s.semPrevisao ? " is-disabled" : "") + (s.dataDraft && !s.semPrevisao ? " is-filled" : ""),
      agendaTechsClass: "oosv2-agenda-techs" + (s.quandoDraft === "futuro" && s.semPrevisao ? " has-notes" : ""),
      setFutureDateFromPicker: (ymd) => {
        const v = String(ymd || "").trim();
        this.setState({ dataDraft: v, semPrevisao: v ? false : s.semPrevisao });
      },
      semPrevisao: !!s.semPrevisao,
      checkSemPrevisaoClass: "oosv2-agenda-check-box" + (s.semPrevisao ? " is-on" : ""),
      toggleSemPrevisao: () => {
        const next = !s.semPrevisao;
        const closePicker = typeof window !== "undefined" ? window.__openOsV2CloseFutureDatePicker : null;
        if (next && typeof closePicker === "function") closePicker();
        if (!next) {
          const cancelVoice = typeof window !== "undefined" ? window.__openOsV2CancelAgendaVoice : null;
          if (typeof cancelVoice === "function") cancelVoice();
        }
        this.setState({
          semPrevisao: next,
          dataDraft: next ? "" : s.dataDraft,
          standbyNotes: next ? s.standbyNotes : ""
        });
      },
      mostrarObsFuturo: !!s.semPrevisao,
      standbyNotes: s.standbyNotes,
      setStandbyNotes: (e) => this.setState({ standbyNotes: e.target.value }),
      standbyNotesErro: notesTrim.length > 0 && notesTrim.length < 10,
      standbyNotesFalta: notesTrim.length > 0 && notesTrim.length < 10 ? ("Faltam " + (10 - notesTrim.length) + " caracteres.") : "",
      standbyNotesAreaClass: "oosv2-agenda-notes" + (notesTrim.length > 0 && notesTrim.length < 10 ? " is-invalid" : ""),
      setDataDraft: (e) => this.setState({ dataDraft: e.target.value }),
      scheduleAreasLoading: !!s.scheduleAreasLoading,
      mostrarRegioesAgenda: !s.scheduleAreasLoading && regioes.length > 0,
      agendaTechQuery: s.agendaTechQuery || "",
      agendaSearchClass: "oosv2-agenda-search" + (String(s.agendaTechQuery || "").trim() ? " is-expanded" : ""),
      setAgendaTechQuery: (e) => this.setState({ agendaTechQuery: e.target.value }),
      routeHelpEnabled: s.quandoDraft === "hoje" || s.quandoDraft === "amanha",
      routeHelpOpen: !!s.routeHelpOpen,
      routeHelpKm: routeKm,
      routeHelpLoading: !!s.routeHelpLoading,
      routeHelpError: s.routeHelpError || "",
      routeHelpActive: routeHelpOn,
      routeHelpOrigin: s.routeHelpOrigin,
      routeHelpOriginAddress: String(s.endereco || "").trim(),
      routeHelpMapPoints: this.filterPointsForSelectedTech(scopedPoints, s.tecnicoDraftObj),
      routeHelpMirrorPoints: this.filterPointsForSelectedTech(scopedPoints, s.tecnicoDraftObj),
      routeHelpColorMap: techColorMap,
      routeHelpDayLabel: s.quandoDraft === "amanha" ? "Amanhã" : "Hoje",
      routeHelpAgendaMirrorOpen: !!s.routeHelpAgendaMirrorOpen,
      routeHelpAgendaMirrorEnabled: routeHelpOn && !!s.tecnicoDraftObj,
      routeHelpAgendaMirrorTechnicianName: s.tecnicoDraft,
      routeHelpAgendaMirrorQuandoDraft: s.quandoDraft,
      routeHelpMonitoredTechs: isGoPremium(this.props.goIdProduto) && s.routeHelpOpen ? (s.routeHelpMonitoredTechs || []) : [],
      toggleRouteHelp: () => this.toggleRouteHelp(),
      setRouteHelpKm: (km) => this.setRouteHelpKm(km),
      cancelarRouteHelp: () => this.cancelarRouteHelp(),
      toggleRouteHelpAgendaMirror: () => this.toggleRouteHelpAgendaMirror(),
      semRegioesAgenda: !s.scheduleAreasLoading && regioes.length === 0 && !routeHelpOn,
      semRegioesRaio: !s.scheduleAreasLoading && routeHelpOn && regioes.length === 0,

      botaoAgendaStyle: "height:34px;padding:0 14px;border-radius:9px;font-size:12.5px;font-weight:700;cursor:pointer;white-space:nowrap;" + (s.agenda ? "border:1px solid #bfe8cf;background:#fff;color:#12a45a" : "border:none;background:#33333f;color:#fff;box-shadow:0 2px 6px rgba(25,25,40,.25)"),
      quandoCardClass: (key) => "oosv2-agenda-quando-card" + (s.quandoDraft === key ? " is-on" : ""),
      quandoTecnico: { pick: () => this.pickQuando("tecnico"), className: "oosv2-agenda-quando-card" + (s.quandoDraft === "tecnico" ? " is-on" : ""), style: cardQuando("tecnico"), iconClassName: "oosv2-agenda-quando-icon" + (s.quandoDraft === "tecnico" ? " is-on" : ""), iconStyle: iconStyle("tecnico") },
      quandoHoje: { pick: () => this.pickQuando("hoje"), className: "oosv2-agenda-quando-card" + (s.quandoDraft === "hoje" ? " is-on" : ""), style: cardQuando("hoje"), dia: cal.hojeDia, dow: cal.hojeDow, dayClassName: "oosv2-agenda-quando-day" + (s.quandoDraft === "hoje" ? " is-on" : ""), dayStyle: diaStyle("hoje"), dowClassName: "oosv2-agenda-quando-dow" + (s.quandoDraft === "hoje" ? " is-on" : ""), dowStyle: dowStyle("hoje") },
      quandoAmanha: { pick: () => this.pickQuando("amanha"), className: "oosv2-agenda-quando-card" + (s.quandoDraft === "amanha" ? " is-on" : ""), style: cardQuando("amanha"), dia: amanhaParts.dia, dow: amanhaParts.dow, dayClassName: "oosv2-agenda-quando-day" + (s.quandoDraft === "amanha" ? " is-on" : ""), dayStyle: diaStyle("amanha"), dowClassName: "oosv2-agenda-quando-dow" + (s.quandoDraft === "amanha" ? " is-on" : ""), dowStyle: dowStyle("amanha") },
      quandoFuturo: { pick: () => this.pickQuando("futuro"), className: "oosv2-agenda-quando-card" + (s.quandoDraft === "futuro" ? " is-on" : ""), style: cardQuando("futuro"), iconClassName: "oosv2-agenda-quando-icon" + (s.quandoDraft === "futuro" ? " is-on" : ""), iconStyle: iconStyle("futuro"), legenda: s.quandoDraft === "futuro" && s.semPrevisao ? "Sem previsão" : (s.quandoDraft === "futuro" && s.dataDraft ? s.dataDraft.split("-").reverse().join("/") : "Agendamento futuro") },

      regioes: regioes,
      agendaDraftResumo: agendaPronta ? s.tecnicoDraft + " · " + dataDoDraft : "Escolha quando e qual técnico",
      confirmarAgendaClass: "oosv2-agenda-confirm-btn" + (agendaPronta ? " is-ready" : " is-disabled"),
      confirmarAgendaStyle: "height:33px;padding:0 14px;border-radius:9px;border:none;font-size:12px;font-weight:700;" + (agendaPronta ? "background:#6d3ef5;color:#fff;cursor:pointer" : "background:#f0f0f5;color:#b4b4c2;cursor:not-allowed"),
      confirmarAgenda: () => {
        if (!agendaPronta || this.props.agendaConfirming) return;
        if (this.props.hideApenasTecnico && s.quandoDraft === "tecnico") return;
        const agendaPayload = {
          tecnico: s.tecnicoDraft,
          tecnicoId: s.tecnicoDraftObj && s.tecnicoDraftObj.id != null ? s.tecnicoDraftObj.id : null,
          tecnicoObj: s.tecnicoDraftObj,
          data: dataDoDraft,
          dataIso: dataIsoDraft,
          quando: s.quandoDraft,
          scheduleType: this.scheduleTypeFromQuando(s.quandoDraft),
          noCertainDate: s.quandoDraft === "futuro" && !!s.semPrevisao,
          standbyNotes: s.quandoDraft === "futuro" && s.semPrevisao ? notesTrim : null
        };
        if (this.props.agendaOnly && typeof this.props.onAgendaConfirm === "function") {
          this.stopMonitoredPoll();
          Promise.resolve(this.props.onAgendaConfirm(agendaPayload)).catch(() => {});
          return;
        }
        this.stopMonitoredPoll();
        this.setState({
          agenda: agendaPayload,
          agendaModal: false,
          routeHelpOpen: false,
          routeHelpAgendaMirrorOpen: false,
          routeHelpOrigin: null,
          routeHelpPoints: [],
          routeHelpError: "",
          routeHelpLoading: false,
          routeHelpMonitoredTechs: []
        });
      },

      voltar: () => this.setState({ step: Math.max(0, s.step - 1) }),
      avancar: async () => {
        if (this.state.guardChecking || this.state.guardAlert) return;
        const nextStep = Math.min(fluxo.length - 1, s.step + 1);
        const patch = { step: nextStep };
        if (isEstoqueMultipla && atual === "equip") {
          if (!s.sel.length) return;
          const ok = await this.ensureGuards(s.sel, () => this.setState(patch));
          if (ok) this.setState(patch);
          return;
        }
        if (isMultipla && atual === "sel") {
          if (mesmoEnderecoMultipla) {
            if (!String(s.endereco || "").trim()) patch.endereco = enderecoCompartilhado;
          } else {
            patch.endereco = "";
            patch.enderecoParsed = null;
            patch.enderecoOriginal = "";
            patch.localInterno = "";
            patch.corrigindoEndereco = false;
            patch.editandoLocalInterno = false;
          }
          const ok = await this.ensureGuards(s.sel, () => this.setState(patch));
          if (!ok) return;
        }
        this.setState(patch);
      },
      gerarLabel: totalSelecionado > 1 ? "Gerar " + totalSelecionado + " ordens de serviço" : "Gerar ordem de serviço",
      gerandoOS: !!s.gerandoOS,
      gerarOS: () => this.gerarOrdens({ isMultipla, selInfos, equipBase, tipoOsValue, tipoLabel: tipoOS }),
      canProgramarPreventiva: this.canProgramarPreventiva(),
      programarPreventivas: () => this.programarPreventivas({ isMultipla, selInfos, equipBase, tipoOsValue, tipoLabel: tipoOS }),
      osGeradas: s.osGeradas,
      preventivasProgramadas: !!s.preventivasProgramadas,
      tituloFinal: s.preventivasProgramadas
        ? (s.osGeradas.length > 1
          ? s.osGeradas.length + " preventivas programadas"
          : "Preventiva programada")
        : (s.osGeradas.length > 1 ? s.osGeradas.length + " ordens de serviço abertas" : "Ordem de serviço aberta"),
      subtituloFinal: s.preventivasProgramadas
        ? ("Geração em " + (s.agenda ? s.agenda.data : (s.preventivaScheduleDate || "—")) + (s.agenda ? " · " + s.agenda.tecnico : "") + " · " + tipoOS)
        : ((s.agenda ? "Programada para " + s.agenda.tecnico + " · " + s.agenda.data : "Sem programação de atendimento") + " · " + tipoOS),
      imprimirLabel: (s.osGeradas || []).filter(o => o && o.success).length > 1 ? "Imprimir todas / PDF" : "Imprimir / PDF",
      variasOS: (s.osGeradas || []).filter(o => o && o.success).length > 1,
      imprimirTodas: () => this.openPrintPreview(),
      enviarTodas: () => this.openEmailModal(),
      imprimirOS: (n) => this.openPrintPreview(n),
      enviarOS: (n) => this.openEmailModal(n),
      emailModalOpen: !!s.emailModal || !!s.emailSentOk,
      emailModalChips: (s.emailModalList || []).map(addr => ({
        addr,
        remove: () => this.setState({ emailModalList: (this.state.emailModalList || []).filter(x => x !== addr) })
      })),
      emailModalDraft: s.emailModalDraft || "",
      setEmailModalDraft: (e) => this.setState({ emailModalDraft: e.target.value, emailSendError: "" }),
      onEmailModalKey: (e) => {
        if (e.key === "Enter" || e.key === "," || e.key === ";") {
          e.preventDefault();
          this.commitEmailModalDraft();
        }
        if (e.key === "Backspace" && !String(this.state.emailModalDraft || "") && (this.state.emailModalList || []).length) {
          this.setState({ emailModalList: this.state.emailModalList.slice(0, -1) });
        }
      },
      onEmailModalBlur: () => this.commitEmailModalDraft(),
      sendEmailModal: () => this.sendEmailModal(),
      closeEmailModal: () => this.closeEmailModal(),
      emailSending: !!s.emailSending,
      emailSentOk: !!s.emailSentOk,
      emailSendError: s.emailSendError || "",
      guardAlert: s.guardAlert,
      guardChecking: !!s.guardChecking,
      continuarGuard: () => this.continuarGuard(),
      cancelarGuard: () => this.cancelarGuard(),
      verOsGuard: (num) => this.verOsGuard(num),
      contratoVencModal: s.contratoVencModal,
      closeContratoVencModal: () => this.closeContratoVencModal(),
      recentOsModal: s.recentOsModal,
      closeRecentOsModal: () => this.setState({ recentOsModal: null }),
      reiniciar: () => this.setState({ step: 0, origem: null, modo: null, query: "", equip: null, cliente: null, locaisLive: [], sel: [], selEstoqueBySerie: {}, filtro: "", solicitante: "", contatoFone1: "", contatoWhatsApp: "", contatoFone2: "", tipoContato: "Fone1", email: "", emails: [], emailDraft: "", defeito: "", defeitoQuery: "", defeitoCodigo: "", defeitoObj: null, defeitoHits: [], defeitoSearching: false, obs: "", tipoOsValue: null, agenda: null, osGeradas: [], gerandoOS: false, concluido: false, preventivasProgramadas: false, preventivaScheduleDate: null, contadoresAberto: false, contPb: "", contCor: "", contTotal: "", lastContPb: 0, lastContCor: 0, lastContTotal: 0, contadoresLoading: false, ultimoAberto: false, laudoAberto: false, defeitoDetalheAberto: false, clienteLabel: "", contratoVencidoFlag: false, contratoVencModal: null, recentOsModal: null, ultimoLive: null, temUltimo: false, histLive: null, histLoading: false, histPeriodMonths: 24, periodoAberto: false, endereco: "", localInterno: "", apiHits: [], scheduleAreasData: null, scheduleAreasLoading: false, tecnicoDraftObj: null, regioesAbertas: [], semPrevisao: false, standbyNotes: "", dataDraft: "", agendaTechQuery: "", emailModal: null, emailModalList: [], emailModalDraft: "", emailSending: false, emailSentOk: false, emailSendError: "", printPreview: null, guardAlert: null, guardChecking: false, routeHelpOpen: false, routeHelpAgendaMirrorOpen: false, routeHelpKm: 5, routeHelpLoading: false, routeHelpError: "", routeHelpOrigin: null, routeHelpPoints: [] }),
      toast: s.toast, temToast: !!s.toast
    };
  }

  render() {
    const preview = this.state.printPreview;
    return (
      <>
        <OpenOsV2View v={this.renderVals()} onClose={this.props.onClose} />
        <OsReportV2PreviewModal
          open={!!preview}
          onClose={() => this.closePrintPreview()}
          orders={preview?.orders}
          includeHistory={preview?.includeHistory !== false}
        />
      </>
    );
  }
}

export default OpenOsV2App;
